var Ho = Object.defineProperty;
var ko = (e, n, t) => n in e ? Ho(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t;
var m = (e, n, t) => ko(e, typeof n != "symbol" ? n + "" : n, t);
import { HierarchyUtils as A, TransformUtils as w, Size as Bn, Vector as Z, ConnectionRootComponent as Ko, SnapRootComponent as $o, DisplayNameComponent as fn, StaticComponent as qo, Transform as rn, SnapUtils as Bt, ComponentIds as U, MathUtils as sn, ColliderUtils as jo, VectorConstants as je, PolyhedronUtils as Hn, SelectableComponent as Yo, OutlineableComponent as Zo, FunctionalZonesLocalComponent as Et, ComponentUtils as Ht, ConnectionUtils as Xo, SnapActionCandidateSortAndSelectStrategies as Jo, RoomDefinitionsUtils as kn, RoomSurfaceType as Ee, ColliderShapeComponent as Qo, PolyhedronGroup as er, ConnectorUtils as nr } from "@inter-ikea-core/core";
import { chunk as tr, isNumber as Mn, xor as _t, xorBy as an, isEqual as On, keyBy as or, clamp as Tn, isArray as kt, unionBy as rr, intersection as sr, cloneDeep as ir } from "lodash-es";
import { SystemBase3 as ar, SystemBase4 as cr, SystemBase2 as lr, SystemBase as ur, SystemBase5 as dr } from "@inter-ikea-core/core-toolbox";
function fr(e) {
  let n = 0, t = 0;
  for (const a of e)
    n += a.w * a.h, t = Math.max(t, a.w);
  e.sort((a, c) => c.h - a.h);
  const r = [{ x: 0, y: 0, w: Math.max(Math.ceil(Math.sqrt(n / 0.95)), t), h: 1 / 0 }];
  let s = 0, i = 0;
  for (const a of e)
    for (let c = r.length - 1; c >= 0; c--) {
      const l = r[c];
      if (!(a.w > l.w || a.h > l.h)) {
        if (a.x = l.x, a.y = l.y, i = Math.max(i, a.y + a.h), s = Math.max(s, a.x + a.w), a.w === l.w && a.h === l.h) {
          const u = r.pop();
          c < r.length && (r[c] = u);
        } else a.h === l.h ? (l.x += a.w, l.w -= a.w) : a.w === l.w ? (l.y += a.h, l.h -= a.h) : (r.push({
          x: l.x + a.w,
          y: l.y,
          w: l.w - a.w,
          h: a.h
        }), l.y += a.h, l.h -= a.h);
        break;
      }
    }
  return {
    w: s,
    // container width
    h: i,
    // container height
    fill: n / (s * i) || 0
    // space utilization
  };
}
var Or = hn("colinear"), hr = hn("parallel"), Er = hn("none");
function _r(e, n, t, o, r, s, i, a) {
  var c = (a - s) * (t - e) - (i - r) * (o - n), l = (i - r) * (n - s) - (a - s) * (e - r), u = (t - e) * (n - s) - (o - n) * (e - r);
  if (c == 0)
    return l == 0 && u == 0 ? Or : hr;
  var d = l / c, h = u / c;
  return d >= 0 && d <= 1 && h >= 0 && h <= 1 ? Ir({
    x: e + d * (t - e),
    y: n + d * (o - n)
  }) : Er;
}
function Ir(e) {
  var n = hn("intersecting");
  return n.point = e, n;
}
function hn(e) {
  return {
    type: e
  };
}
function It(e, n, t, o, r, s) {
  if (t != r) {
    if (t <= e && e <= r || t >= e && e >= r) return !0;
  } else if (o <= n && n <= s || o >= n && n >= s) return !0;
  return !1;
}
var pr = Object.defineProperty, gr = (e, n, t) => n in e ? pr(e, n, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[n] = t, Y = (e, n, t) => gr(e, typeof n != "symbol" ? n + "" : n, t);
function Ke(e, n) {
  return { x: e.x + n.x, y: e.y + n.y };
}
function Kt(...e) {
  let n = C(0, 0);
  for (const t of e)
    n.x += t.x, n.y += t.y;
  return n;
}
function q(e, n) {
  return C(e.x - n.x, e.y - n.y);
}
function Kn(e, n) {
  return $t(e, n) ? C(1e-3, 0) : q(e, n);
}
function Nr(e, n) {
  return C(e.x * n.x, e.y * n.y);
}
function ae(e) {
  return Math.sqrt(e.x * e.x + e.y * e.y);
}
function En(e, n) {
  return C(e.x * n, e.y * n);
}
function Pe(e, n) {
  return { x: e.x / n, y: e.y / n };
}
function xe(e) {
  return Pe(e, ae(e));
}
function $n(e, n) {
  return e.x * n.x + e.y * n.y;
}
function Cr(e) {
  return C(Math.abs(e.x), Math.abs(e.y));
}
function mr(...e) {
  return Pe(Kt(...e), e.length);
}
function Rr({ x: e, y: n }) {
  return C(n, e);
}
function Mr(e, n) {
  const t = Math.sin(n), o = Math.cos(n);
  return C(e.x * o - e.y * t, e.x * t + e.y * o);
}
function Tr(e, n) {
  return xe(q(n, e));
}
function Ar(e) {
  return C(-e.y, e.x);
}
function Dr(e) {
  return C(e.y, -e.x);
}
function Lr(e) {
  return C(Math.round(e.x), Math.round(e.y));
}
function xr(e, n) {
  return C(Math.round(e.x / n) * n, Math.round(e.y / n) * n);
}
function le(e, n) {
  return e.x === n.x && e.y === n.y;
}
function $t(e, n) {
  return ae(q(e, n)) <= 1e-3;
}
function qn(e) {
  const n = e.reduce((t, o) => Ke(t, o), C());
  return En(n, 1 / e.length);
}
const cn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  abs: Cr,
  add: Ke,
  almostEquals: $t,
  avg: mr,
  direction: Tr,
  divs: Pe,
  dot: $n,
  geometricMean: qn,
  isSame: le,
  length: ae,
  mul: Nr,
  muls: En,
  normalize: xe,
  rotate: Mr,
  rotateRightAngleClockwise: Ar,
  rotateRightAngleCounterClockwise: Dr,
  round: Lr,
  roundFractional: xr,
  safeSub: Kn,
  sub: q,
  sum: Kt,
  transpose: Rr
}, Symbol.toStringTag, { value: "Module" })), pt = Math.PI, ge = 2 * Math.PI, De = {
  x: O(1, 0, 0),
  y: O(0, 1, 0),
  z: O(0, 0, 1)
};
function G(e = 0, n = 0, t = 0, o = 0) {
  return { x: e, y: n, z: t, w: o };
}
function O(e = 0, n = 0, t = 0) {
  return { x: e, y: n, z: t };
}
function C(e = 0, n = 0) {
  return { x: e, y: n };
}
function V(e, n) {
  return { x: e.x + n.x, y: e.y + n.y, z: e.z + n.z };
}
function yr(...e) {
  return e.reduce((n, t) => ({
    x: n.x + t.x,
    y: n.y + t.y,
    z: n.z + t.z
  }));
}
function K(e, n) {
  return O(e.x - n.x, e.y - n.y, e.z - n.z);
}
function ee(e, n) {
  return Pr(e, n) ? O(1e-3, 0, 0) : K(e, n);
}
function Ua(e, n) {
  return e.x === n.x && e.y === n.y && e.z === n.z;
}
function Pr(e, n) {
  return B(K(e, n)) <= 1e-3;
}
function B(e) {
  return Math.sqrt(e.x * e.x + e.y * e.y + e.z * e.z);
}
function Fa(e, n) {
  return B(K(e, n));
}
function b(e, n) {
  return O(e.x * n, e.y * n, e.z * n);
}
function Ga(e, n) {
  return O(e.x * n.x, e.y * n.y, e.z * n.z);
}
function me(e, n) {
  return { x: e.x / n, y: e.y / n, z: e.z / n };
}
function te(e) {
  return me(e, B(e));
}
function se(e, n) {
  return e.x * n.x + e.y * n.y + e.z * n.z;
}
function Va(e) {
  return e.x >= e.y && e.x >= e.z ? e.x : e.y >= e.z ? e.y : e.z;
}
function Ba(e, n) {
  return O(Math.min(e.x, n.x), Math.min(e.y, n.y), Math.min(e.z, n.z));
}
function Ha(e, n) {
  return O(Math.max(e.x, n.x), Math.max(e.y, n.y), Math.max(e.z, n.z));
}
function ka(e) {
  return O(Math.abs(e.x), Math.abs(e.y), Math.abs(e.z));
}
function Ka(e) {
  return Math.abs(e.y) < Math.abs(e.x) ? O(e.z, 0, -e.x) : O(0, e.z, -e.y);
}
function Oe(e, n) {
  return O(e.y * n.z - e.z * n.y, e.z * n.x - e.x * n.z, e.x * n.y - e.y * n.x);
}
function ue(e) {
  return C(e.x, -e.z);
}
function ve(e) {
  return Math.atan2(-e.z, e.x);
}
function $a(e, n) {
  e = te(e);
  const t = Math.sin(n / 2);
  return G(e.x * t, e.y * t, e.z * t, Math.cos(n / 2));
}
function jn(e, n, t) {
  return { c0: e, c1: n, c2: t };
}
function vr(e, n, t) {
  return jn(O(e.x, n.x, t.x), O(e.y, n.y, t.y), O(e.z, n.z, t.z));
}
function qa(e) {
  return jn(O(e.c0.x, e.c1.x, e.c2.x), O(e.c0.y, e.c1.y, e.c2.y), O(e.c0.z, e.c1.z, e.c2.z));
}
function Je(e, n) {
  return O(se(e.c0, n), se(e.c1, n), se(e.c2, n));
}
function W(e, n) {
  return (e % n + n) % n;
}
function ja(e) {
  const n = e.c0, t = e.c1, o = e.c2;
  return n.x * (t.y * o.z - o.y * t.z) - t.x * (n.y * o.z - o.y * n.z) + o.x * (n.y * t.z - t.y * n.z);
}
function ie(e, n, t) {
  return e === void 0 ? n : O(
    e.c0.x * n.x + e.c0.y * n.y + e.c0.z * n.z + e.c0.w * t,
    e.c1.x * n.x + e.c1.y * n.y + e.c1.z * n.z + e.c1.w * t,
    e.c2.x * n.x + e.c2.y * n.y + e.c2.z * n.z + e.c2.w * t
  );
}
function $(e, n) {
  return e.x * n.x + e.y * n.y + e.z * n.z + e.w * n.w;
}
function Sr(e) {
  return {
    c0: G(e.c0.x, e.c1.x, e.c2.x, e.c2.x),
    c1: G(e.c0.y, e.c1.y, e.c2.y, e.c2.y),
    c2: G(e.c0.z, e.c1.z, e.c2.z, e.c2.z),
    c3: G(e.c0.w, e.c1.w, e.c2.w, e.c2.w)
  };
}
function Qe(e, n) {
  const t = Sr(e);
  return {
    c0: G($(t.c0, n.c0), $(t.c1, n.c0), $(t.c2, n.c0), $(t.c3, n.c0)),
    c1: G($(t.c0, n.c1), $(t.c1, n.c1), $(t.c2, n.c1), $(t.c3, n.c1)),
    c2: G($(t.c0, n.c2), $(t.c1, n.c2), $(t.c2, n.c2), $(t.c3, n.c2)),
    c3: G($(t.c0, n.c3), $(t.c1, n.c3), $(t.c2, n.c3), $(t.c3, n.c3))
  };
}
function qt() {
  return {
    c0: G(1, 0, 0, 0),
    c1: G(0, 1, 0, 0),
    c2: G(0, 0, 1, 0),
    c3: G(0, 0, 0, 1)
  };
}
function An(e) {
  const n = qt();
  return n.c0 = G(e.c0.x, e.c0.y, e.c0.z, 0), n.c1 = G(e.c1.x, e.c1.y, e.c1.z, 0), n.c2 = G(e.c2.x, e.c2.y, e.c2.z, 0), n;
}
function Wr(e) {
  return {
    c0: G(1, 0, 0, e.x),
    c1: G(0, 1, 0, e.y),
    c2: G(0, 0, 1, e.z),
    c3: G(0, 0, 0, 1)
  };
}
function wr(e) {
  let n = { c0: O(), c1: O(), c2: O() };
  const t = Math.cos(e), o = Math.sin(e);
  return n.c0 = O(1, 0, 0), n.c1 = O(0, t, o), n.c2 = O(0, -o, t), n;
}
function zr(e) {
  let n = { c0: O(), c1: O(), c2: O() };
  const t = Math.cos(-e), o = Math.sin(-e);
  return n.c0 = O(t, 0, -o), n.c1 = O(0, 1, 0), n.c2 = O(o, 0, t), n;
}
function br(e) {
  let n = { c0: O(), c1: O(), c2: O() };
  const t = Math.cos(e), o = Math.sin(e);
  return n.c0 = O(t, o, 0), n.c1 = O(-o, t, 0), n.c2 = O(0, 0, 1), n;
}
function Ya(e, n) {
  let t = qt();
  return n && (t = Qe(An(wr(n.x)), t), t = Qe(An(zr(n.y)), t), t = Qe(An(br(n.z)), t)), e && (t = Qe(Wr(e), t)), t;
}
function gt(e, n) {
  const t = n.o.x - e.o.x, o = n.o.y - e.o.y, r = n.d.x * e.d.y - n.d.y * e.d.x;
  if (Math.abs(r) < 1e-5)
    return;
  let s = (o * n.d.x - t * n.d.y) / r;
  return Ke(e.o, En(e.d, s));
}
function Ur(e, n, t) {
  if (le(e.p1, n.p1) && le(e.p2, n.p2) || le(e.p1, n.p2) && le(e.p2, n.p1))
    return "overlapping";
  const o = _r(
    e.p1.x,
    e.p1.y,
    e.p2.x,
    e.p2.y,
    n.p1.x,
    n.p1.y,
    n.p2.x,
    n.p2.y
  );
  if (o.type === "none" || o.type === "parallel")
    return !1;
  const r = It(n.p1.x, n.p1.y, e.p1.x, e.p1.y, e.p2.x, e.p2.y) && !(le(n.p1, e.p1) || le(n.p1, e.p2)), s = It(n.p2.x, n.p2.y, e.p1.x, e.p1.y, e.p2.x, e.p2.y) && !(le(n.p2, e.p1) || le(n.p2, e.p2));
  if (o.type === "colinear") {
    const i = ae(q(e.p1, e.p2)), a = ae(q(n.p1, n.p2));
    return t ? i !== a && !(i < 1 || a < 1) && (r || s) ? o.type : !1 : i < 1 || a < 1 ? !1 : r || s ? o.type : !1;
  }
  return t ? !1 : o.type;
}
function Za(e, n, t) {
  return (1 - t) * e + t * n;
}
function Xa(e, n, t) {
  return Gr(e, n) > 0 ? e > n && (n += ge) : e < n && (n -= ge), e + t * (n - e);
}
function Fr(e) {
  return (e + ge) % ge;
}
function Gr(e, n) {
  let t = (n - e) % ge;
  return t < -pt ? t += ge : t > pt && (t -= ge), t;
}
function Vr(e, n, t) {
  return V(b(e, 1 - t), b(n, t));
}
function Ja(e, n, t, o = !1) {
  const r = K(n, e), s = B(r), i = me(r, s);
  let a = se(K(t, e), i) / s;
  return o || (a = Math.max(Math.min(a, 1), 0)), Vr(e, n, a);
}
function Qa(e, n, t) {
  const o = t.x, r = e.x, s = n.x, i = t.y, a = e.y, c = n.y, l = Math.abs((s - r) * (a - i) - (r - o) * (c - a)), u = Math.sqrt(Math.pow(s - r, 2) + Math.pow(c - a, 2));
  return l / u;
}
function ec(e) {
  const n = Math.cos(e.theta), t = Math.sin(e.theta), o = Math.cos(e.phi), r = Math.sin(e.phi);
  return O(n * r * e.radius, o * e.radius, -t * r * e.radius);
}
function nc(e) {
  const n = B(e), t = Fr(Math.atan2(-e.z, e.x)), o = Math.acos(se(O(0, 1, 0), me(e, n)));
  return {
    theta: t,
    phi: o,
    radius: n
  };
}
function tc(e, n, t) {
  const o = se(e, n), r = Math.acos(o), s = Math.sin(r), i = Math.sin((1 - t) * r) / s, a = Math.sin(t * r) / s;
  return V(b(e, i), b(n, a));
}
function oc(e) {
  let n = 0, t = e.length - 1;
  for (let o = 0; o < e.length; o++) {
    const r = e[t], s = e[o], i = s.x - r.x, a = (r.y + s.y) * 0.5, c = i * a;
    n += c, t = o;
  }
  return n;
}
function Br(e, n) {
  return Math.abs(e - n) < 1e-8;
}
function Hr(e, n, t) {
  return Math.min(Math.max(e, n), t);
}
function rc(e) {
  return me(e, 1e3);
}
const Dn = 2;
function kr(e = 0, n = 0, t = 0, o = 0) {
  return { x1: e, y1: n, x2: t, y2: o };
}
class ye {
  constructor(n, t) {
    Y(this, "width"), Y(this, "height"), Y(this, "rotate"), Y(this, "placement"), this.width = n, this.height = t, this.rotate = !1, this.placement = kr();
  }
}
class Kr {
  constructor(n) {
    Y(this, "resolutionX"), Y(this, "resolutionY"), Y(this, "padding"), Y(this, "desiredTexelsPerMeter"), Y(this, "rectangles"), this.rectangles = [], this.resolutionX = 256, this.resolutionY = 256, this.padding = 2, this.desiredTexelsPerMeter = n;
  }
  /** Add a rectangle to the atlas */
  addRectangle(n, t) {
    const o = Math.max(Dn, n), r = Math.max(Dn, t);
    let s = new ye(o, r);
    return this.rectangles.push(s), s;
  }
  getResolution() {
    return {
      width: this.resolutionX,
      height: this.resolutionY
    };
  }
  /** Pack rectangles, filling in their 'placement' attributes with x and y coordinates */
  atlas() {
    this.rectangles.sort((i, a) => a.width - i.width);
    const n = this.rectangles.map((i) => ({
      w: i.width,
      h: i.height,
      rect: i
    })), t = fr(n), o = 8, r = 12;
    this.resolutionX = this.resolutionY = Math.pow(
      Dn,
      Math.round(
        Hr(
          Math.log2(this.desiredTexelsPerMeter * Math.max(t.w, t.h)),
          o,
          r
          /* 4096 */
        )
      )
    );
    const s = this.padding / this.resolutionX;
    n.forEach((i) => {
      if (i.x !== void 0 && i.y !== void 0) {
        const a = i.x / t.w, c = (i.x + i.w) / t.w, l = i.y / t.h, u = (i.y + i.h) / t.h;
        i.rect.placement = {
          x1: a > 1e-4 ? a + s : a,
          x2: c < 0.9999 ? c - s : c,
          y1: l > 1e-4 ? l + s : l,
          y2: u < 0.9999 ? u - s : u
        };
      }
    });
  }
}
var $r = /* @__PURE__ */ ((e) => (e.HINGED = "HINGED", e.SLIDING = "SLIDING", e.FIXED = "FIXED", e))($r || {}), zn = /* @__PURE__ */ ((e) => (e.SINGLE = "SINGLE", e.DOUBLE = "DOUBLE", e.OPENING = "OPENING", e))(zn || {}), de = /* @__PURE__ */ ((e) => (e.DOOR = "DOOR", e.WINDOW = "WINDOW", e))(de || {}), be = /* @__PURE__ */ ((e) => (e.RIGHT = "RIGHT", e.TOP = "TOP", e.BOTTOM = "BOTTOM", e.LEFT = "LEFT", e))(be || {}), jt = /* @__PURE__ */ ((e) => (e.INWARDS = "INWARDS", e.OUTWARDS = "OUTWARDS", e))(jt || {});
function Ie(e) {
  return (e == null ? void 0 : e.type) === de.DOOR;
}
function he(e) {
  return (e == null ? void 0 : e.type) === de.WINDOW;
}
function qr(e) {
  return typeof e != "number";
}
const Yn = 0, Zn = 8;
function jr() {
  return {
    versionMajor: Yn,
    versionMinor: Zn,
    rooms: [],
    materials: {},
    metadata: {}
  };
}
function Yr(e) {
  return Yt(e, 1e3);
}
function sc(e) {
  return Yt(e, 1e-3);
}
function Yt(e, n) {
  const t = e.rooms.map((o) => {
    const r = o.corners.map((i) => ({
      ...i,
      x: i.x / n,
      y: i.y / n,
      z: i.z / n
    })), s = o.walls.map((i) => {
      var a, c;
      const l = i.thickness ? i.thickness / n : null;
      let u;
      qr(i.height) ? u = {
        vertices: i.height.vertices.map((I) => C(I.x / n, I.y / n))
      } : u = i.height / n;
      const d = (a = i.features) == null ? void 0 : a.map((I) => {
        const g = {
          ...I,
          positionAlongWall: I.positionAlongWall / n,
          size: {
            width: I.size.width / n,
            height: I.size.height / n,
            depth: I.size.depth / n
          }
        };
        return he(I) ? {
          ...g,
          groundClearance: I.groundClearance / n
        } : g;
      }), h = (c = i.holes) == null ? void 0 : c.map((I) => ({
        vertices: I.vertices.map((g) => C(g.x / n, g.y / n))
      }));
      return l ? {
        ...i,
        height: u,
        thickness: l,
        features: d,
        holes: h
      } : {
        ...i,
        height: u,
        features: d,
        holes: h
      };
    });
    return {
      ...o,
      corners: r,
      walls: s
    };
  });
  return {
    ...e,
    rooms: t
  };
}
function ic(e, n, t, o) {
  const r = e, s = e + t, i = n, a = n + o;
  return {
    vertices: [C(r, i), C(r, a), C(s, a), C(s, i)]
  };
}
function ac(e, n, t) {
  let o = [];
  const r = 2 * Math.PI / t;
  for (let s = 0; s < t; s++) {
    let i = s * r;
    o.push(C(e.x - Math.cos(i) * n, e.y + Math.sin(i) * n));
  }
  return {
    vertices: o
  };
}
function Zr(e) {
  let n = [], t = {};
  for (const r of e.walls) {
    const s = r, i = e.corners[r.leftIndex], a = e.corners[r.rightIndex], c = te(ee(a, i)), l = Oe(c, De.y);
    s.outward = l, s.tangent = c, t[r.leftIndex] || (t[r.leftIndex] = {}), t[r.leftIndex].rightWall = s, t[r.rightIndex] || (t[r.rightIndex] = {}), t[r.rightIndex].leftWall = s;
  }
  const o = Object.entries(t).map(([, r]) => {
    const { leftWall: s, rightWall: i } = r;
    let a = V(s.outward, i.outward);
    return a = me(a, se(a, s.outward) || 1), {
      leftWall: r.leftWall,
      rightWall: r.rightWall,
      offset: a
    };
  });
  for (const r of e.walls) {
    let s = r;
    s.nextWall = o[r.rightIndex].rightWall, s.prevWall = o[r.leftIndex].leftWall, s.offsetLeft = o[r.leftIndex].offset, s.offsetRight = o[r.rightIndex].offset, n.push(s);
  }
  return n;
}
class Xr {
  constructor() {
    Y(this, "counter", 1);
  }
  generateId() {
    return this.counter++;
  }
}
function H(e, n, t) {
  e[n] = t.x, e[n + 1] = t.y, e[n + 2] = t.z;
}
function Fe(e, n, ...t) {
  for (let o of t)
    e[n++] = o;
}
function Xn(e) {
  let n = -1 / 0, t = -1 / 0, o = 1 / 0, r = 1 / 0;
  for (const s of e)
    o = Math.min(o, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), t = Math.max(t, s.y);
  return {
    min: C(o, r),
    max: C(n, t),
    width: Math.abs(n - o),
    height: Math.abs(t - r)
  };
}
function Zt(e, n) {
  return [
    // prettier-ignore
    C(0, 0),
    C(e, 0),
    C(e, n),
    C(0, n)
  ];
}
function Jr(e, n, t, o) {
  const r = e.y - n.y, s = n.x - e.x, i = e.x * n.y - n.x * e.y, a = t.y - o.y, c = o.x - t.x, l = t.x * o.y - o.x * t.y, u = r * c - a * s;
  if (u === 0)
    return;
  const d = (c * i - s * l) / -u, h = (a * i - r * l) / u, I = Math.min(t.x, o.x) - 1e-5, g = Math.max(t.x, o.x) + 1e-5, M = Math.min(t.y, o.y) - 1e-5, x = Math.max(t.y, o.y) + 1e-5;
  if (d > g || d < I || h > x || h < M)
    return;
  const p = -(d - e.x);
  if (!(p <= 0))
    return { x: d, y: h, distance: p };
}
function Qr(e, n) {
  const t = e.map((u, d) => ({
    a: u,
    b: e[W(d + 1, e.length)]
  })), o = Xn(e);
  for (const u of n)
    u.x === 0 && (u.x += 1e-4), u.x === o.width && (u.x -= 1e-4);
  const r = {
    a: n[0],
    b: { x: n[0].x - 1, y: n[0].y }
  };
  let s = 1 / 0, i = -1, a = e[0];
  for (let u = 0; u < t.length; u++) {
    const d = t[u];
    let h = Jr(r.a, r.b, d.a, d.b);
    h !== void 0 && h.distance < s && (s = h.distance, i = u, a = { x: h.x, y: h.y });
  }
  const c = e[i], l = e[W(i + 1, e.length)];
  Math.abs(a.x - c.x) < 0.01 && Math.abs(a.y - c.y) < 0.01 ? e.splice(i + 1, 0, ...n, n[0], c) : Math.abs(a.x - l.x) < 0.01 && Math.abs(a.y - l.y) < 0.01 ? e.splice(i + 2, 0, ...n, n[0], l) : e.splice(i + 1, 0, a, ...n, n[0], a);
}
function tn(e, n, t) {
  const o = n.x - e.x, r = n.y - e.y, s = t.x - e.x, i = t.y - e.y;
  let a = Math.atan2(o * i - r * s, o * s + r * i);
  return a < 0 && (a += Math.PI * 2), Math.abs(a);
}
function ln(e, n, t) {
  const o = te(K(n, e)), r = te(K(t, e)), s = se(o, r);
  let i = Math.acos(s);
  return i < 0 && (i += Math.PI * 2), Math.abs(i);
}
function Ln(e, n, t) {
  return (e.x - t.x) * (n.y - t.y) - (n.x - t.x) * (e.y - t.y);
}
function es(e, n, t, o) {
  const r = Ln(e, n, t);
  if (r < 0)
    return !1;
  const s = Ln(e, t, o);
  if (s < 0)
    return !1;
  const i = Ln(e, o, n);
  return !(i < 0 || (r === 0 ? 1 : 0) + (s === 0 ? 1 : 0) + (i === 0 ? 1 : 0) > 1);
}
function Xt(e, n, t, o, r = 0, s = !1, i = void 0) {
  let a = new Float32Array(e.length * 3), c = new Float32Array(e.length * 3);
  const l = i ?? b(Oe(t, o), s ? -1 : 1), u = b(l, r);
  for (let E = 0; E < e.length; E++) {
    const R = e[E];
    Fe(
      a,
      E * 3,
      R.x * t.x + R.y * o.x + u.x,
      R.x * t.y + R.y * o.y + u.y,
      R.x * t.z + R.y * o.z + u.z
    ), H(c, E * 3, l);
  }
  let d = [];
  for (let E = 0; E < e.length; E++)
    d.push({
      angle: tn(e[E], e[W(E + 1, e.length)], e[W(E - 1, e.length)]),
      vertex: E
    });
  let h = [];
  for (; d.length > 2; ) {
    const E = d.reduce(
      (S, v, P) => {
        const F = () => {
          if (v.angle > Math.PI)
            return !1;
          const Q = d[P], Me = W(P - 1, d.length), Te = W(P + 1, d.length), Cn = d[Me], Xe = d[Te], mn = e[Q.vertex], Rn = e[Xe.vertex], Bo = e[Cn.vertex];
          for (let Ae = 0; Ae < d.length; Ae++)
            if (!(Ae === Me || Ae === P || Ae === Te) && es(e[d[Ae].vertex], mn, Rn, Bo))
              return !1;
          return !0;
        };
        return v.angle < S.angle && F() ? {
          ...v,
          index: P
        } : {
          ...S,
          index: S.index
        };
      },
      { angle: 1 / 0, vertex: -1, index: -1 }
    ), R = d[W(E.index - 1, d.length)], D = d[W(E.index + 1, d.length)];
    s ? h.push(E.vertex, R.vertex, D.vertex) : h.push(E.vertex, D.vertex, R.vertex);
    const T = d[W(E.index - 2, d.length)], y = d[W(E.index + 2, d.length)];
    R.angle = tn(e[R.vertex], e[D.vertex], e[T.vertex]), D.angle = tn(e[D.vertex], e[y.vertex], e[R.vertex]), d.splice(E.index, 1);
  }
  const I = new Float32Array(e.length * 2), g = new Float32Array(e.length * 2);
  let M = 1 / 0, x = -1 / 0, p = 1 / 0, L = -1 / 0;
  for (let E = 0; E < e.length; E++)
    I[E * 2] = e[E].x, I[E * 2 + 1] = e[E].y, x = Math.max(x, e[E].x), L = Math.max(L, e[E].y), M = Math.min(M, e[E].x), p = Math.min(p, e[E].y);
  const N = x - M, _ = L - p;
  for (let E = 0; E < e.length; E++)
    g[E * 2 + 0] = n.placement.x1 + (e[E].x - M) / N * (n.placement.x2 - n.placement.x1), g[E * 2 + 1] = n.placement.y1 + (e[E].y - p) / _ * (n.placement.y2 - n.placement.y1);
  return {
    positions: a,
    normals: c,
    indices: new Uint16Array(h),
    uv0: I,
    uv1: g
  };
}
function ns(e, n, t, o, r = 0, s = !1, i = void 0) {
  let a = new Float32Array(e.length * 3), c = new Float32Array(e.length * 3);
  const l = i ?? b(Oe(t, o), s ? -1 : 1);
  e.forEach((_, E) => {
    Fe(
      a,
      E * 3,
      _.x,
      // v.x * baseU.x + v.y * baseV.x + normal.x * offsetAlongNormal,
      _.y,
      // v.x * baseU.y + v.y * baseV.y + normal.y * offsetAlongNormal,
      _.z
      // v.x * baseU.z + v.y * baseV.z + normal.z * offsetAlongNormal
    ), H(c, E * 3, l);
  });
  let u = [];
  for (let _ = 0; _ < e.length; _++)
    u.push({
      angle: tn(e[_], e[W(_ + 1, e.length)], e[W(_ - 1, e.length)]),
      vertex: _
    });
  let d = [];
  for (; u.length > 2; ) {
    const _ = u.reduce(
      (y, S, v) => {
        const P = () => {
          if (S.angle > Math.PI)
            return !1;
          const F = u[v], Q = W(v - 1, u.length), Me = W(v + 1, u.length), Te = u[Q], Cn = u[Me], Xe = e[F.vertex], mn = e[Cn.vertex], Rn = e[Te.vertex];
          return !(Oe(K(mn, Xe), K(Rn, Xe)).y >= 0);
        };
        return S.angle < y.angle && P() ? {
          ...S,
          index: v
        } : {
          ...y,
          index: y.index
        };
      },
      { angle: 1 / 0, vertex: -1, index: -1 }
    ), E = u[W(_.index - 1, u.length)], R = u[W(_.index + 1, u.length)];
    s ? d.push(_.vertex, E.vertex, R.vertex) : d.push(_.vertex, R.vertex, E.vertex);
    const D = u[W(_.index - 2, u.length)], T = u[W(_.index + 2, u.length)];
    E.angle = ln(e[E.vertex], e[R.vertex], e[D.vertex]), R.angle = ln(e[R.vertex], e[T.vertex], e[E.vertex]), u.splice(_.index, 1);
  }
  const h = new Float32Array(e.length * 2), I = new Float32Array(e.length * 2);
  let g = 1 / 0, M = -1 / 0, x = 1 / 0, p = -1 / 0;
  for (let _ = 0; _ < e.length; _++)
    h[_ * 2] = e[_].x, h[_ * 2 + 1] = e[_].z, M = Math.max(M, e[_].x), p = Math.max(p, e[_].z), g = Math.min(g, e[_].x), x = Math.min(x, e[_].z);
  const L = M - g, N = p - x;
  for (let _ = 0; _ < e.length; _++)
    I[_ * 2 + 0] = n.placement.x1 + (e[_].x - g) / L * (n.placement.x2 - n.placement.x1), I[_ * 2 + 1] = n.placement.y1 + (e[_].z - x) / N * (n.placement.y2 - n.placement.y1);
  return {
    positions: a,
    normals: c,
    indices: new Uint16Array(d),
    uv0: h,
    uv1: I
  };
}
function Nt(e) {
  const n = C(1 / 0, 1 / 0), t = C(-1 / 0, -1 / 0);
  for (let o of e.vertices)
    n.x = Math.min(o.x, n.x), n.y = Math.min(o.y, n.y), t.x = Math.max(o.x, t.x), t.y = Math.max(o.y, t.y);
  return { min: n, max: t };
}
function Ct(e, n) {
  const t = {
    vertices: [],
    closed: e.closed
  }, o = [];
  for (let r = 0; r < e.vertices.length - 1; r++)
    o.push({
      start: e.vertices[r],
      end: e.vertices[r + 1]
    });
  e.closed && o.push({
    start: e.vertices[e.vertices.length - 1],
    end: e.vertices[0]
  });
  for (let r of o) {
    const s = xe(q(r.end, r.start)), i = C(-s.y, s.x), a = En(i, n);
    r.start = Ke(r.start, a), r.end = Ke(r.end, a), r.dir = s;
  }
  if (e.closed) {
    const r = o[o.length - 1], s = o[0], i = gt(
      {
        o: r.start,
        d: r.dir
      },
      {
        o: s.start,
        d: s.dir
      }
    );
    if (!i)
      throw new Error();
    t.vertices.push(i);
  }
  for (let r = 1; r < o.length; r++) {
    const s = o[r - 1], i = o[r], a = gt(
      {
        o: s.start,
        d: s.dir
      },
      {
        o: i.start,
        d: i.dir
      }
    );
    if (!a)
      throw new Error();
    t.vertices.push(a);
  }
  return t;
}
function ts(e) {
  const n = e.length * 0.5;
  let t = 0, o = [], r = [];
  r.push(0);
  for (let p = 1; p < e.vertices.length; p++) {
    const L = e.vertices[p], N = e.vertices[p - 1], _ = q(L, N), E = ae(_), R = Pe(_, E);
    o.push(Je(e.base, O(R.y, -R.x, 0))), t += E, r.push(t);
  }
  const s = {};
  let i = 0;
  const a = Math.cos(Math.PI * 0.16);
  if (e.closed) {
    const p = q(e.vertices[0], e.vertices[e.vertices.length - 1]), L = ae(p), N = Pe(p, L);
    t += L, r.push(t);
    const _ = Je(e.base, O(N.y, -N.x, 0));
    o.push(_);
  }
  for (let p = 1; p < e.vertices.length; p++) {
    const L = o[p], N = o[p - 1];
    se(L, N) < a && (s[p] = !0, i += 1);
  }
  const c = e.closed ? 1 : 0, l = (e.vertices.length + i + c) * 2, u = new Float32Array(l * 3), d = new Float32Array(l * 3), h = new Float32Array(l * 2);
  let I = [], g = 0, M = 0;
  for (let p = 0; p < e.vertices.length; p++) {
    const L = e.vertices[p], N = Je(e.base, O(L.x, L.y, -n)), _ = Je(e.base, O(L.x, L.y, n)), E = o[W(p - 1, o.length)], R = o[p], D = s[p] ? E : te(V(E, R));
    H(u, g, N), H(u, g + 3, _), H(d, g, D), H(d, g + 3, D);
    let T = r[p];
    Fe(h, M, T, 0, T, e.length), s[p] && (H(u, g + 6, N), H(u, g + 9, _), H(d, g + 6, R), H(d, g + 9, R), Fe(h, M + 4, T, 0, T, e.length));
    const y = s[p] ? 2 : 1;
    g += 6 * y, M += 4 * y;
  }
  let x = 2;
  for (let p = 1; p < e.vertices.length; p++) {
    const L = x - 2, N = x - 1, _ = x, E = x + 1;
    I.push(L, N, E, L, E, _), x += s[p] ? 4 : 2;
  }
  if (e.closed) {
    const p = o[o.length - 1], L = se(p, o[0]) < a, N = u.length - 6;
    for (let P = 0; P < 6; P++)
      u[N + P] = u[P], L || (d[N + P] = d[P]);
    if (L) {
      const P = o[0];
      H(d, 0, P), H(d, 3, P);
      const F = o[o.length - 1];
      H(d, N, F), H(d, N + 3, F);
    }
    const _ = r.length - 1, E = _ * 4;
    let R = r[_];
    Fe(h, E, R, 0, R, e.length);
    const D = (e.vertices.length + i) * 2, T = D - 2, y = D - 1, S = D, v = D + 1;
    I.push(T, y, v, T, v, S);
  }
  return {
    positions: u,
    normals: d,
    indices: new Uint16Array(I),
    uv0: h
  };
}
function mt(e, n = 0.503) {
  const t = {
    hardNormals: {},
    hardNormalCount: 0,
    arcLength: 0,
    segmentNormals: []
  }, o = Math.cos(n), r = e.closed ? e.vertices.length : e.vertices.length - 1;
  for (let i = 0; i < r; i++) {
    const a = e.vertices[i], c = e.vertices[W(i + 1, e.vertices.length)], l = q(c, a), u = ae(l), d = Pe(l, u);
    t.arcLength += u;
    const h = C(d.y, -d.x);
    t.segmentNormals.push(h);
  }
  const s = e.closed ? 0 : 1;
  for (let i = s; i < r; i++) {
    const a = t.segmentNormals[i], c = t.segmentNormals[W(i - 1, e.vertices.length)];
    $n(a, c) < o && (t.hardNormals[i] = !0, t.hardNormalCount += 1);
  }
  return t;
}
function os(e) {
  const n = e.path, t = e.profile, o = mt(n), r = mt(t, Math.PI / 8), s = t.vertices.length + r.hardNormalCount, i = n.vertices.length + o.hardNormalCount, a = s * i, c = new Float32Array(a * 3), l = new Float32Array(a * 3), u = new Float32Array(a * 2), d = [], h = n.vertices.map((N, _) => {
    const E = n.vertices[W(_ - 1, n.vertices.length)], R = n.vertices[W(_ + 1, n.vertices.length)], D = xe(q(E, N)), T = xe(q(R, N));
    return Math.acos($n(D, T));
  }), I = [], g = n.vertices.length - (n.closed ? 0 : 1);
  for (let N = 0; N < g; N++) {
    const _ = N, E = W(N + 1, n.vertices.length), R = n.vertices[_], D = n.vertices[E], T = xe(q(D, R)), y = C(-T.y, T.x), S = O(T.x, T.y, 0), v = O(y.x, y.y, 0), P = te(Oe(S, v));
    I.push({
      fromIndex: _,
      toIndex: E,
      from: R,
      to: D,
      profileX: P,
      profileY: v,
      profileZ: S
    });
  }
  const M = [];
  let x = 0;
  for (let N = 0; N < t.vertices.length; N++)
    r.hardNormals[N] ? (M.push({
      to: x,
      from: x + 1
    }), x += 2) : (M.push({
      to: x,
      from: x
    }), x += 1);
  let p = 0;
  const L = (N, _, E) => {
    for (let R = 0; R < t.vertices.length; R++) {
      const D = t.vertices[R], T = V(
        _,
        V(
          V(b(N.profileX, D.x), b(N.profileY, D.y)),
          b(N.profileZ, E * D.y)
        )
      );
      if (r.hardNormals[R]) {
        const S = p * 3;
        H(c, S, T);
        {
          const v = r.segmentNormals[W(R - 1, t.vertices.length)], P = V(b(N.profileY, v.y), b(N.profileX, v.x));
          H(l, S, P);
        }
        p += 1;
      }
      const y = p * 3;
      H(c, y, T);
      {
        const S = r.segmentNormals[R], v = V(b(N.profileY, S.y), b(N.profileX, S.x));
        H(l, y, v);
      }
      p += 1;
    }
  };
  for (let N of I) {
    let _ = 0, E = 0;
    const R = O(N.from.x, N.from.y, 0);
    if (o.hardNormals[N.fromIndex]) {
      _ = p;
      const T = 1 / Math.tan(h[N.fromIndex] * 0.5);
      L(N, R, T);
    } else
      N.fromIndex === 0 ? L(N, R, 0) : _ = p - s;
    const D = O(N.to.x, N.to.y, 0);
    if (o.hardNormals[N.toIndex]) {
      E = p;
      const T = 1 / Math.tan(h[N.toIndex] * 0.5);
      L(N, D, -T);
    } else if (E = p, n.closed && N.toIndex === 0)
      E = 0;
    else if (N.toIndex === n.vertices.length - 1)
      L(N, D, 0);
    else {
      E = p;
      const T = 1 / Math.tan(h[N.toIndex] * 0.5);
      L(N, D, -T);
    }
    for (let T = 0; T < t.vertices.length - 1; T++) {
      const y = M[T], S = M[T + 1], v = _ + y.from, P = _ + S.to, F = E + y.from, Q = E + S.to;
      d.push(v, F, Q, v, Q, P);
    }
    if (t.closed) {
      const T = M[t.vertices.length - 1], y = M[0], S = _ + T.from, v = _ + y.to, P = E + T.from, F = E + y.to;
      d.push(S, P, F, S, F, v);
    }
  }
  return {
    positions: c,
    normals: l,
    indices: new Uint16Array(d),
    uv0: u
  };
}
function cc(e, n) {
  if (!he(e) && !Ie(e))
    return [];
  const t = Ie(e), o = O(e.size.width, e.size.height, e.size.depth), r = t ? "DOOR_PART" : "WINDOW_PART", s = ds(o, t).map((c) => ({
    ...c,
    geometryType: r
  })), i = ss(o, t, e.handleLocation), a = [...s, ...i];
  if (n)
    for (const c of a)
      for (let l = 0; l < c.positions.length; l += 3)
        c.positions[l] = c.positions[l] - e.size.width / 2, c.positions[l + 1] = c.positions[l + 1] - e.size.height / 2;
  return a;
}
function rs(e, n = "square") {
  switch (n) {
    case "square":
      return Mt(e);
    case "arc":
      return as(e);
    case "circle":
      return cs(e);
  }
  return Mt(e);
}
function ss(e, n = !1, t) {
  let o = O(), r;
  const s = O(0.03, 0.03, 0.06), i = O(0, 0, 0.03);
  switch (t) {
    case be.RIGHT:
      o = O(e.x - (s.x * 2 + 5e-3), e.y / 2, 0), i.x = n ? 0.15 : s.x, i.y = n ? s.y : 0.15, r = O(
        o.x - (i.x - s.x),
        e.y / 2 - (i.y - s.y),
        o.z + s.z
      );
      break;
    default:
    case be.LEFT:
      o = O(s.x + 5e-3, e.y / 2, 0), i.x = n ? 0.15 : s.x, i.y = n ? s.y : 0.15, r = O(o.x, e.y / 2 - (i.y - s.y), o.z + s.z);
      break;
    case be.TOP:
      if (n)
        return [];
      i.x = 0.15, i.y = s.y, o = O(e.x / 2 + 5e-3 - i.x / 2, e.y - (s.y * 2 + 5e-3), 0), r = O(o.x, e.y - (s.y * 2 + 5e-3), o.z + s.z);
      break;
    case be.BOTTOM:
      if (n)
        return [];
      i.x = 0.15, i.y = s.y, o = O(e.x / 2 + 5e-3 - i.x / 2, s.y + 5e-3, 0), r = O(o.x, s.y, o.z + s.z);
      break;
  }
  const a = Rt(s, o), c = Rt(i, r);
  return [a, c].map((l) => ({
    ...l,
    geometryType: "HANDLE_PART"
  }));
}
function is(e, n = O()) {
  const t = new Float32Array([
    n.x,
    n.y,
    n.z,
    n.x,
    n.y + e.y,
    n.z,
    n.x + e.x,
    n.y + e.y,
    n.z,
    n.x + e.x,
    n.y,
    n.z
  ]), o = new Uint16Array([2, 1, 0, 3, 2, 0]);
  return {
    positions: t,
    indices: o
  };
}
function Rt(e, n = O()) {
  const t = new Float32Array([
    n.x,
    n.y,
    n.z + e.z,
    n.x + e.x,
    n.y,
    n.z + e.z,
    n.x + e.x,
    n.y,
    n.z,
    n.x,
    n.y,
    n.z,
    n.x,
    n.y + e.y,
    n.z + e.z,
    n.x + e.x,
    n.y + e.y,
    n.z + e.z,
    n.x + e.x,
    n.y + e.y,
    n.z,
    n.x,
    n.y + e.y,
    n.z
  ]), o = new Uint16Array([
    0,
    1,
    2,
    0,
    2,
    3,
    0,
    1,
    5,
    0,
    5,
    4,
    3,
    0,
    4,
    3,
    4,
    7,
    2,
    3,
    7,
    2,
    7,
    6,
    1,
    2,
    6,
    1,
    6,
    5,
    4,
    5,
    6,
    4,
    6,
    7
  ]);
  return {
    positions: t,
    indices: o
  };
}
function Mt(e) {
  return [
    C(0, e.y),
    C(e.x, e.y),
    C(e.x, 0),
    C(0, 0)
  ];
}
function as(e) {
  const n = e.x / 2, t = [C(0, 0.8 * e.y)];
  for (let o = 16; o > 1; o--) {
    const r = o / 16 * Math.PI;
    t.push(C(n + Math.cos(r) * n, 0.8 * e.y + Math.sin(r) * n));
  }
  return t.push(C(e.x, 0.8 * e.y), C(e.x, 0), C(0, 0)), t;
}
function cs(e) {
  const n = [], t = e.x / 2, o = e.y / 2;
  for (let r = 31; r > -1; r--) {
    let s = Math.PI * 2 * (r / 32);
    n.push(C(
      t + Math.cos(s + Math.PI) * t,
      o + Math.sin(s + Math.PI) * o
    ));
  }
  return n;
}
function ls(e, n = !1) {
  const t = {
    vertices: [
      C(0.05, 0),
      C(0.05, 0.01),
      C(0.04, 0.02),
      C(-0.04, 0.02),
      C(-0.05, 0.01),
      C(-0.05, 0)
    ],
    closed: !0
  }, o = {
    vertices: [
      C(0.01, 0),
      C(0.02, 0.01),
      C(0.02, 0.05),
      C(0.01, 0.06),
      C(-0.01, 0.06),
      C(-0.02, 0.05),
      C(-0.02, 0.01),
      C(-0.01, 0)
    ],
    closed: !0
  }, r = Nt(t), s = Nt(o), i = Ct({ vertices: e.vertices, closed: !0 }, r.max.y), a = Ct(i, s.max.y), c = [
    // Outer frame is just a profile extruded along the outline of the window.
    Tt(e, t),
    // The inner frame is another profile extruded along a curve that is inset from the input outline
    // to match the inner edge of the outer frame.
    Tt(i, o)
    // The outline of the glass pane is the inner edge of the inner frame,
    //,
  ];
  return n && c.push(us(a)), c;
}
function Tt(e, n) {
  return os({
    path: e,
    profile: n,
    id: -1,
    type: Le.SKIRTING,
    sourceId: ""
  });
}
function us(e) {
  return Xt(e.vertices, new ye(0, 0), O(1, 0, 0), O(0, 1, 0));
}
function ds(e, n = !1) {
  return ls(
    {
      vertices: [C(e.x, 0), C(e.x, e.y), C(0, e.y), C(0, 0)],
      closed: !n
    },
    n
  );
}
function _n(e = !1) {
  return (n, t) => e ? t.positionAlongWall - n.positionAlongWall : n.positionAlongWall - t.positionAlongWall;
}
function lc(e) {
  let n = O(1 / 0, 1 / 0, 1 / 0), t = O(-1 / 0, -1 / 0, -1 / 0);
  for (let s of e.corners)
    n.x = Math.min(n.x, s.x), n.y = Math.min(n.y, s.y), n.z = Math.min(n.z, s.z), t.x = Math.max(t.x, s.x), t.y = Math.max(t.y, s.y), t.z = Math.max(t.z, s.z);
  let o = -1 / 0;
  for (let s of e.walls)
    if (typeof s.height == "number")
      o = Math.max(o, s.height);
    else
      for (let i of s.height.vertices)
        o = Math.max(o, i.y);
  let r = O((n.x + t.x) * 0.5, t.y + o, (n.z + t.z) * 0.5);
  return e.transform && (r = ie(e.transform, r, 1)), r;
}
const Jt = 0.07, fs = 0.07, At = 0.07;
var Le = /* @__PURE__ */ ((e) => (e.FLOOR = "FLOOR", e.CEILING = "CEILING", e.WALL = "WALL", e.SKIRTING = "SKIRTING", e.WALL_HOLE_SIDE = "WALL_HOLE_SIDE", e.THICKNESS = "THICKNESS", e.WALLFEATURE = "WALLFEATURE", e.WALLFEATURE_ELEMENT = "WALLFEATURE_ELEMENT", e))(Le || {});
function Os(e, n, t, o) {
  let r = 0;
  for (let s = 1; s < e.length; s++) {
    const i = e[s], a = e[s - 1];
    r += ae(q(i, a));
  }
  return n && (r += ae(q(e[0], e[e.length - 1]))), t.addRectangle(r, o);
}
function Jn(e) {
  let n = e.length, t = 5381, o = 52711;
  for (; n--; ) {
    const r = e.charCodeAt(n);
    t = t * 33 ^ r, o = o * 33 ^ r;
  }
  return (t >>> 0) * 4096 + (o >>> 0);
}
function uc(e, n) {
  return n >= e.length && (n -= e.length), n < 0 && (n += e.length), e[n];
}
function Se(e) {
  return typeof e == "number";
}
function Qt(e) {
  if (Se(e))
    return e;
  {
    const n = e.vertices;
    let t = -1 / 0;
    for (let o of n)
      t = Math.max(t, o.y);
    return t;
  }
}
function hs(e) {
  if (Se(e))
    return e;
  {
    const n = e.vertices;
    let t = 1 / 0;
    for (let o of n)
      t = Math.min(t, o.y);
    return t;
  }
}
function un(e, n) {
  e[n] || (e[n] = {
    walls: [],
    floors: [],
    ceilings: []
  });
}
function Es(e) {
  const n = {};
  return e.rooms.forEach((t) => {
    const o = Zr(t), { corners: r } = t;
    o.forEach((s) => {
      const i = s.thickness ?? Jt, a = r[s.leftIndex], c = r[s.rightIndex], l = 3e5;
      B(s.offsetLeft) > l && (s.offsetLeft = b(te(s.offsetLeft), l)), B(s.offsetRight) > l && (s.offsetRight = b(te(s.offsetRight), l));
      const u = V(a, b(s.offsetLeft, -i)), d = V(c, b(s.offsetRight, -i));
      n[s.id] = { left: u, right: d };
    });
  }), n;
}
function _s({ blueprint: e, idgen: n, thickWalls: t }) {
  const o = Yr(e);
  let r = new Kr(32);
  const s = {
    meshes: [],
    atlas: r
  };
  let i = [], a = [], c = [];
  for (let u of o.rooms)
    Is(
      { surfaces: i, extrueSurfaces: a, nonplanarSurfaces: c, result: s },
      n,
      u,
      o,
      r,
      t
    );
  r.atlas();
  for (let u = 0; u < i.length; u++) {
    const d = i[u], h = Xt(
      d.vertices,
      d.uv1,
      d.baseU,
      d.baseV,
      d.offset ?? 0,
      d.flip,
      d.overrideNormal
    );
    s.meshes.push(Dt(h, d, n));
  }
  for (let u = 0; u < c.length; u++) {
    const d = c[u], h = ns(
      d.vertices,
      d.uv1,
      d.baseU,
      d.baseV,
      d.offset ?? 0,
      d.flip,
      d.overrideNormal
    );
    s.meshes.push(Dt(h, d, n));
  }
  for (let u = 0; u < a.length; u++) {
    const d = a[u], h = ts(d);
    s.meshes.push({
      geometry: h,
      uid: n.generateId(),
      stableId: d.id,
      sourceId: d.sourceId,
      position: d.position,
      parent: d.parentID,
      rotation: O(),
      type: d.type,
      wallOutwardDirection: d.wallOutwardDirection
    });
  }
  const l = (u, d) => {
    const h = [
      "FLOOR",
      "CEILING",
      "WALL",
      "WALLFEATURE",
      "WALLFEATURE_ELEMENT",
      "SKIRTING",
      "WALL_HOLE_SIDE",
      "THICKNESS"
      /* THICKNESS */
    ];
    return h.indexOf(u.type) - h.indexOf(d.type);
  };
  return s.meshes.sort(l), s;
}
function Dt(e, n, t) {
  return {
    geometry: e,
    uid: t.generateId(),
    stableId: n.id,
    sourceId: n.sourceId,
    position: n.position,
    rotation: n.rotation,
    parent: n.parentID,
    type: n.type,
    coordinateSpace: vr(
      n.baseU,
      n.baseV,
      b(Oe(n.baseU, n.baseV), n.flip ? -1 : 1)
    ),
    measurement: n.measurement,
    wallOutwardDirection: n.wallOutwardDirection,
    material: n.material
  };
}
function Is(e, n, t, o, r, s) {
  const i = {}, a = Es(o);
  for (let c of t.walls) {
    if (un(i, c.leftIndex), un(i, c.rightIndex), i[c.leftIndex].walls.push(c), i[c.rightIndex].walls.push(c), !Se(c.height))
      throw new Error("Sloped ceilings are not supported!");
    const l = t.corners[c.leftIndex], u = t.corners[c.rightIndex], d = ee(u, l), h = te(d), I = ve(h), g = B(d), M = c.thickness ?? Jt;
    let x = me(d, g), p = De.y, L = l;
    t.transform && (x = ie(t.transform, x, 0), p = ie(t.transform, p, 0), L = ie(t.transform, L, 1));
    const N = jn(x, p, Oe(p, x)), _ = Qt(c.height), E = hs(c.height), R = Zt(g, _), { baseU: D, baseV: T } = Ye();
    e.surfaces.push({
      wallOutwardDirection: O(h.z, h.y, -h.x),
      id: n.generateId(),
      type: "WALL",
      vertices: R,
      baseU: D,
      baseV: T,
      position: L,
      rotation: O(0, I, 0),
      sourceId: c.id,
      uv1: r.addRectangle(g, _),
      material: c.materialId ? o.materials[c.materialId] : void 0
    }), s && Ns(e.surfaces, n, r, a, c, t);
    const y = (c.features ?? []).sort(_n()), S = O(h.z, h.y, -h.x);
    let v = 0;
    const P = y.map((F) => {
      const Q = Cs(F, g, v, E);
      v = Q.leftMinBound;
      const Me = yr(
        l,
        b(h, F.positionAlongWall),
        O(0, F.groundClearance ?? 0, 0)
      ), Te = {
        geometry: is(O(F.size.width, F.size.height, F.size.depth), O()),
        uid: Math.random(),
        stableId: Math.random(),
        sourceId: F.id,
        position: Me,
        rotation: O(0, I, 0),
        type: "WALLFEATURE"
        /* WALLFEATURE */
      };
      return e.result.meshes.push(Te), Q;
    });
    P.length && ms(
      e.extrueSurfaces,
      P,
      t,
      c,
      l,
      N,
      S,
      M,
      R,
      r
    );
  }
  t.floors.forEach((c) => {
    e.surfaces.push(gs(t, c, i, r, o.materials));
  }), t.ceilings.forEach((c) => {
    e.surfaces.push(ps(t, c, i, r, o.materials));
  });
  for (let c in i)
    if (i[c].walls.length === 2) {
      const l = i[c].walls[0], u = i[c].walls[1];
      if (l.height !== u.height)
        throw new Error("Connected walls have mismatched height.");
    }
  for (let c of t.walls) {
    const l = c.leftIndex, u = c.rightIndex;
    if (i[l].floors[0].id, i[u].floors[0].id, i[l].ceilings[0].id === i[u].ceilings[0].id && !Se(c.height))
      throw new Error("Slanted ceiling not supported.");
  }
}
function ps(e, n, t, o, r) {
  let s = Array(n.nodes.length);
  for (let I = 0; I < n.nodes.length; I++) {
    const g = n.nodes[I];
    s[I] = ue(e.corners[g]), un(t, g), t[g].ceilings.push(n);
  }
  const { min: i, max: a } = Xn(s);
  if (!Se(e.walls[0].height))
    throw new Error("Invalid height!");
  const c = qn(s), l = s.map((I) => Kn(I, c));
  let u = O(0, e.walls[0].height, 0);
  e.transform && (u = ie(e.transform, u, 1));
  const { baseU: d, baseV: h } = Ye(0, e.transform);
  return {
    id: Jn(n.id),
    sourceId: n.id,
    vertices: l,
    uv1: o.addRectangle(Math.abs(a.x - i.x), Math.abs(a.y - i.y)),
    baseU: d,
    baseV: h,
    position: u,
    rotation: O(),
    type: "CEILING",
    flip: !0,
    overrideNormal: O(0, -1, 0),
    material: n.materialId ? r[n.materialId] : void 0
  };
}
function gs(e, n, t, o, r) {
  let s = Array(n.nodes.length);
  for (let g = 0; g < n.nodes.length; g++) {
    const M = n.nodes[g];
    s[g] = ue(e.corners[M]), un(t, M), t[M].floors.push(n);
  }
  let i = e.corners[n.nodes[0]].y;
  const { min: a, max: c } = Xn(s), l = qn(s), u = s.map((g) => Kn(g, l));
  let d = ie(e.transform, O(0, i, 0), 1);
  const { baseU: h, baseV: I } = Ye(0, e.transform);
  return {
    id: Jn(n.id),
    sourceId: n.id,
    vertices: u,
    uv1: o.addRectangle(Math.abs(c.x - a.x), Math.abs(c.y - a.y)),
    baseU: h,
    baseV: I,
    position: d,
    rotation: O(),
    type: "FLOOR",
    flip: !1,
    overrideNormal: O(0, 1, 0),
    material: n.materialId ? r[n.materialId] : void 0
  };
}
function Ns(e, n, t, o, r, s) {
  const i = s.corners[r.leftIndex], a = s.corners[r.rightIndex], c = te(ee(a, i)), l = Qt(r.height);
  let u = o[r.id].left, d = o[r.id].left, h = o[r.id].right;
  const I = O(0, 1, 0);
  s.transform && (u = ie(s.transform, u, 1), d = ie(s.transform, d, 1), h = ie(s.transform, h, 1));
  const g = B(ee(o[r.id].right, o[r.id].left)), M = O(c.z, c.y, -c.x), x = [
    // prettier-ignore
    ue(o[r.id].left),
    ue(i),
    ue(a),
    ue(o[r.id].right)
  ], p = O(-M.x, -M.y, -M.z);
  let L = o[r.id].left.y, { baseU: N, baseV: _ } = Ye(0, s.transform);
  e.push({
    wallOutwardDirection: p,
    baseU: N,
    baseV: _,
    overrideNormal: I,
    id: n.generateId(),
    sourceId: r.id + "bottom",
    parentID: s.floors[0].id,
    vertices: x,
    uv1: new ye(g, B(ee(o[r.id].left, i))),
    position: O(0, L, 0),
    rotation: O(),
    type: "THICKNESS",
    flip: !1
  }), e.push({
    wallOutwardDirection: p,
    baseU: N,
    baseV: _,
    overrideNormal: I,
    id: n.generateId(),
    sourceId: r.id + "ceiling",
    parentID: s.ceilings[0].id,
    vertices: x,
    uv1: new ye(g, B(ee(o[r.id].left, i))),
    position: O(0, L + l, 0),
    rotation: O(),
    type: "THICKNESS",
    flip: !0
  });
  const E = [
    C(),
    ue(ee(i, o[r.id].left)),
    ue(ee(a, o[r.id].left)),
    ue(ee(o[r.id].right, o[r.id].left))
  ];
  e.push({
    wallOutwardDirection: M,
    id: n.generateId(),
    sourceId: r.id + "up",
    parentID: r.id,
    vertices: E,
    uv1: new ye(g, B(ee(o[r.id].left, i))),
    baseU: s.transform ? s.transform.c0 : O(1, 0, 0),
    baseV: s.transform ? s.transform.c2 : O(0, 0, -1),
    position: V(o[r.id].left, O(0, l, 0)),
    rotation: O(),
    type: "THICKNESS",
    flip: !1,
    overrideNormal: O(0, 1, 0)
  });
  const R = en(n.generateId(), r.id + "under", {
    start: o[r.id].left,
    end: o[r.id].right,
    height: At,
    position: K(u, O(0, At, 0)),
    flip: !0,
    type: "THICKNESS",
    plane: 1,
    wallOutwardDirection: p
  });
  R.parentID = s.floors[0].id, e.push(R);
  const D = en(n.generateId(), r.id + "top", {
    start: o[r.id].left,
    end: o[r.id].right,
    height: fs,
    position: V(u, O(0, l, 0)),
    flip: !0,
    type: "THICKNESS",
    plane: 1,
    wallOutwardDirection: O(0, 1, 0)
  });
  D.parentID = s.ceilings[0].id, e.push(D);
  const T = en(n.generateId(), r.id + "LeftSide", {
    start: o[r.id].left,
    end: i,
    height: l,
    position: d,
    flip: !1,
    type: "THICKNESS",
    plane: 1,
    overrideNormal: I,
    wallOutwardDirection: M
  });
  T.parentID = r.id, e.push(T);
  const y = en(n.generateId(), r.id + "RightSide", {
    start: o[r.id].right,
    end: a,
    height: l,
    position: h,
    flip: !0,
    type: "THICKNESS",
    plane: 1,
    overrideNormal: I,
    wallOutwardDirection: M
  });
  y.parentID = r.id, e.push(y);
}
function Ye(e = 1, n) {
  let t, o;
  switch (e) {
    case 1:
      t = De.x, o = De.y;
      break;
    case 2:
      t = De.y, o = De.z;
      break;
    case 0:
      t = n ? n.c0 : O(1, 0, 0), o = n ? n.c2 : O(0, 0, -1);
      break;
  }
  return { baseU: t, baseV: o };
}
function en(e, n, t) {
  const o = B(ee(t.end, t.start)), r = te(ee(t.end, t.start));
  let s = ve(r), i;
  t.plane !== 0 ? (s = ve(r), i = O(0, s, 0)) : i = O();
  const a = Zt(o, t.height), { baseU: c, baseV: l } = Ye(t.plane, t.roomTransform);
  let u = new ye(o, t.height);
  t.atlas && (u = t.atlas.addRectangle(o, t.height));
  const d = {
    id: e,
    vertices: a,
    uv1: u,
    rotation: i,
    baseU: c,
    baseV: l,
    sourceId: n,
    position: t.position,
    flip: t.flip,
    type: t.type
  };
  return t.overrideNormal && (d.overrideNormal = t.overrideNormal), t.wallOutwardDirection && (d.wallOutwardDirection = t.wallOutwardDirection), d;
}
function Cs(e, n, t, o) {
  const r = e.positionAlongWall, s = e.groundClearance ?? 0;
  let i = 0;
  const a = rs(C(e.size.width, e.size.height)).map((c) => (i = Math.max(c.x + r, i), C(
    Math.min(Math.max(c.x + r, t + 1e-3), n - 1e-3),
    Math.min(Math.max(c.y + s, 1e-3), o - 1e-3)
  )));
  return t = Math.max(t, i), {
    /** TO-DO: Do we really need an array of objects here?
     * Each entry in the holes array contains only points,
     * so it seems like it'd be better to just have an array
     * of sub-arrays of points...
     * - Simon Lundberg */
    vertices: a,
    leftMinBound: t,
    featureId: e.id
  };
}
function ms(e, n, t, o, r, s, i, a, c, l) {
  let u = V(r, b(s.c2, a * 0.5));
  t.transform && (u = ie(t.transform, u, 1));
  let d = 0;
  for (let h of n) {
    d++, Qr(c, h.vertices);
    const I = {
      wallOutwardDirection: i,
      id: Jn(`${d}`),
      sourceId: [o.id, h.featureId, "hole", d].join("-"),
      vertices: h.vertices,
      parentID: h.featureId,
      closed: !0,
      length: a,
      base: s,
      position: u,
      uv1: Os(c, closed, l, a),
      type: "WALL_HOLE_SIDE"
      /* WALL_HOLE_SIDE */
    };
    e.push(I);
  }
}
var Rs = /* @__PURE__ */ ((e) => (e.CREATE = "CREATE", e.DELETE = "DELETE", e.REPLACE = "REPLACE", e))(Rs || {});
class dc {
  constructor() {
    Y(this, "idgen", new Xr()), Y(this, "currentMeshes", []), Y(this, "subscribers", []), Y(this, "blueprint", null);
  }
  emitEvent(n) {
    this.subscribers.forEach((t) => t(n));
  }
  /**
   * Adds a change listener/callback that is called when a blueprint update changes a mesh.
   * @param f The callback function.
   */
  subscribe(n) {
    this.subscribers.push(n);
  }
  /**
   * Remove a change listener.
   * @param f The callback function to remove.
   */
  unsubscribe(n) {
    this.subscribers.includes(n) && this.subscribers.splice(this.subscribers.indexOf(n), 1);
  }
  /**
   * Removes all change listeners
   */
  unsubscribeAll() {
    this.subscribers = [];
  }
  /**
   * Returns current JSON representation of the space.
   */
  getJSON() {
    return this.blueprint;
  }
  /**
   * Update the blueprint. This will generate new meshes and trigger change events.
   * @param blueprint
   */
  update(n, t = !1) {
    this.blueprint = n;
    const o = _s({
      blueprint: n,
      idgen: this.idgen,
      thickWalls: t
    });
    for (let r of this.currentMeshes) {
      const s = {
        type: "DELETE",
        id: r
      };
      this.emitEvent(s);
    }
    this.currentMeshes = [];
    for (let r of o.meshes) {
      this.currentMeshes.push(r.sourceId);
      const s = {
        type: "CREATE",
        mesh: r
      };
      this.emitEvent(s);
    }
    return o;
  }
}
var Ms = /* @__PURE__ */ ((e) => (e.NONE = "none", e.INCREASE = "increase", e.DECREASE = "decrease", e))(Ms || {}), ne = /* @__PURE__ */ ((e) => (e.CORNER = "CORNER", e.WALL_FEATURE = "WALL_FEATURE", e.WALL = "WALL", e.FLOOR = "FLOOR", e.CEILING = "CEILING", e))(ne || {}), Ts = /* @__PURE__ */ ((e) => (e.EDITOR_MODE_2D = "EDITOR_MODE_2D", e.EDITOR_MODE_3D = "EDITOR_MODE_3D", e))(Ts || {}), eo = /* @__PURE__ */ ((e) => (e.RIGHT = "RIGHT", e.LEFT = "LEFT", e))(eo || {}), no = /* @__PURE__ */ ((e) => (e.LEFT = "left", e.RIGHT = "right", e.UP = "up", e.DOWN = "down", e))(no || {}), As = /* @__PURE__ */ ((e) => (e.CLOSED = "CLOSED", e.MODIFY_ROOM = "MODIFY_ROOM", e.STRUCTURAL_OBJECTS = "STRUCTURAL_OBJECTS", e.ROOM_STYLE = "ROOM_STYLE", e.WALL_COVERINGS = "WALL_COVERINGS", e.CEILING_COVERINGS = "CEILING_COVERINGS", e.FLOOR_COVERINGS = "FLOOR_COVERINGS", e.EDIT_STRUCTURAL_OBJECT = "EDIT_STRUCTURAL_OBJECT", e))(As || {}), Ds = /* @__PURE__ */ ((e) => (e.COMPONENT = "COMPONENT", e.LIST = "LIST", e.BUTTONS = "BUTTONS", e.DRAG_BUTTONS = "DRAG_BUTTONS", e.CLOSED = "CLOSED", e.SECTIONS = "SECTIONS", e))(Ds || {}), Ls = /* @__PURE__ */ ((e) => (e.cuboid = "cuboid", e.lShape = "lShape", e.bayWindow = "bayWindow", e.cuboidWindowDoor = "cuboidWindowDoor", e))(Ls || {}), f = /* @__PURE__ */ ((e) => (e[e.ROOM_COMPONENT_ID = 107e3] = "ROOM_COMPONENT_ID", e[e.ROOM_WALL_COMPONENT_ID = 107002] = "ROOM_WALL_COMPONENT_ID", e[e.ROOM_FLOOR_COMPONENT_ID = 107003] = "ROOM_FLOOR_COMPONENT_ID", e[e.ROOM_CEILING_COMPONENT_ID = 107004] = "ROOM_CEILING_COMPONENT_ID", e[e.ROOM_EDGE_COMPONENT_ID = 107005] = "ROOM_EDGE_COMPONENT_ID", e[e.ROOM_CORNER_COMPONENT_ID = 107006] = "ROOM_CORNER_COMPONENT_ID", e[e.ROOM_SURFACE_COMPONENT_ID = 107007] = "ROOM_SURFACE_COMPONENT_ID", e[e.ROOM_CORNER_RELATION_COMPONENT_ID = 107009] = "ROOM_CORNER_RELATION_COMPONENT_ID", e[e.ROOM_UNDER_CONSTRUCTION_COMPONENT_ID = 107010] = "ROOM_UNDER_CONSTRUCTION_COMPONENT_ID", e[e.ROOM_EDGE_RELATION_COMPONENT_ID = 107011] = "ROOM_EDGE_RELATION_COMPONENT_ID", e[e.ROOM_SURFACE_RELATIONS_COMPONENT_ID = 107012] = "ROOM_SURFACE_RELATIONS_COMPONENT_ID", e[e.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID = 107013] = "ROOM_PARAMETRIC_OBJECT_COMPONENT_ID", e[e.ROOM_DOOR_COMPONENT_ID = 107014] = "ROOM_DOOR_COMPONENT_ID", e[e.ROOM_WINDOW_COMPONENT_ID = 107015] = "ROOM_WINDOW_COMPONENT_ID", e[e.ROOM_MATERIAL_COMPONENT_ID = 107016] = "ROOM_MATERIAL_COMPONENT_ID", e[e.ROOM_MATERIAL_STORAGE_COMPONENT_ID = 107017] = "ROOM_MATERIAL_STORAGE_COMPONENT_ID", e[e.ROOM_MATERIAL_PREVIEW_COMPONENT_ID = 107018] = "ROOM_MATERIAL_PREVIEW_COMPONENT_ID", e[e.SCENE_RELOADING_COMPONENT_ID = 107019] = "SCENE_RELOADING_COMPONENT_ID", e[e.CUSTOM_MESH_COMPONENT = 107020] = "CUSTOM_MESH_COMPONENT", e[e.PARAMETRIC_PART_COMPONENT = 107021] = "PARAMETRIC_PART_COMPONENT", e[e.UI_WIDGET_COMPONENT = 107022] = "UI_WIDGET_COMPONENT", e[e.BLUEPRINT_COMPONENT_ID = 107023] = "BLUEPRINT_COMPONENT_ID", e[e.KVADRAT_COMPONENT_ID = 107024] = "KVADRAT_COMPONENT_ID", e[e.KVADRAT_LOCAL_COMPONENT_ID = 107025] = "KVADRAT_LOCAL_COMPONENT_ID", e[e.KVADRAT_ACTIVE_COMPONENT_ID = 107026] = "KVADRAT_ACTIVE_COMPONENT_ID", e[e.SHOULD_BE_INTERACTABLE_COMPONENT_ID = 107027] = "SHOULD_BE_INTERACTABLE_COMPONENT_ID", e[e.EXCLUDE_WALL_FEATURE_FROM_BLUEPRINT_COMPONENT_ID = 107028] = "EXCLUDE_WALL_FEATURE_FROM_BLUEPRINT_COMPONENT_ID", e[e.SURFACE_RESIZING_COMPONENT_ID = 107029] = "SURFACE_RESIZING_COMPONENT_ID", e[e.UPDATE_HOST_CONNECTIONS_COMPONENT_ID = 107030] = "UPDATE_HOST_CONNECTIONS_COMPONENT_ID", e[e.WALL_THICKNESS_COMPONENT_ID = 107031] = "WALL_THICKNESS_COMPONENT_ID", e[e.VIEWER_UPDATE_OBSERVER_COMPONENT_ID = 107032] = "VIEWER_UPDATE_OBSERVER_COMPONENT_ID", e[e.EDITOR_MODE_COMPONENT_ID = 107033] = "EDITOR_MODE_COMPONENT_ID", e[e.EDITING_COMPONENT_ID = 107034] = "EDITING_COMPONENT_ID", e[e.OPENING_DIRECTION_COMPONENT_ID = 107035] = "OPENING_DIRECTION_COMPONENT_ID", e[e.OPENING_ARC_COMPONENT_ID = 107036] = "OPENING_ARC_COMPONENT_ID", e[e.GRID_COMPONENT_ID = 107037] = "GRID_COMPONENT_ID", e[e.VISUAL_GRID_PLANE_COMPONENT_ID = 107038] = "VISUAL_GRID_PLANE_COMPONENT_ID", e[e.ROOM_SLOPED_CEILING_COMPONENT_ID = 107039] = "ROOM_SLOPED_CEILING_COMPONENT_ID", e))(f || {});
function Qn(e) {
  if (e[0] !== "#")
    return;
  let n = e.slice(1);
  if (n.length !== 3 && n.length !== 6)
    return;
  n.length === 3 && (n = n[0] + n[0] + n[1] + n[1] + n[2] + n[2]);
  const [t, o, r] = tr(n, 2).map((s) => parseInt(s.join(""), 16) / 256);
  if (!(!Mn(t) && !Mn(o) && !Mn(r)))
    return {
      r: t,
      g: o,
      b: r
    };
}
const xs = "8.0.1-alpha.0", fc = xs, Oc = 0.1, hc = 0.8, Ec = 0.03, _c = 40, Ic = "kvadrat-measurement", pc = 0.02, gc = 300, Nc = 15e3, Cc = 1e5, mc = 1, Rc = 0.02, Mc = 0.2;
Le.WALL, Le.FLOOR, Le.CEILING, Le.WALLFEATURE;
const Tc = 0.75, Ac = Qn("#0058A3"), Dc = Qn("#0058A3"), Lc = Qn("#0058A3"), xc = "Kvadrat-Ui", yc = "IKEA_KVADRAT_SHOW_ONBOARDING", ys = 300, Ps = 500, vs = 500, Ss = 500, Pc = "kvadrat";
var Ws = /* @__PURE__ */ ((e) => (e.MATERIALCATEGORY = "kvadrat-materialcategory", e.MATERIAL = "kvadrat-material", e))(Ws || {}), ws = /* @__PURE__ */ ((e) => (e.MATERIALCATEGORY = "kvad-materialcategory", e.MATERIALCATEGORY_WALL = "kvad-materialcategory-wall", e.MATERIALCATEGORY_FLOOR = "kvad-materialcategory-floor", e.MATERIALCATEGORY_CEILING = "kvad-materialcategory-ceiling", e.MATERIAL = "kvad-material", e.MATERIAL_WALL = "kvad-material-wall", e.MATERIAL_WALL_TILE = "kvad-material-wall-tile", e.MATERIAL_WALL_WALLPAPER = "kvad-material-wall-wallpaper", e.MATERIAL_WALL_CONCRETE = "kvad-material-wall-concrete", e.MATERIAL_WALL_COLOR = "kvad-material-wall-color", e.MATERIAL_FLOOR = "kvad-material-floor", e.MATERIAL_FLOOR_TILE = "kvad-material-floor-tile", e.MATERIAL_FLOOR_CONCRETE = "kvad-material-floor-concrete", e.MATERIAL_FLOOR_HARDWOOD = "kvad-material-floor-hardwood", e.MATERIAL_CEILING = "kvad-material-ceiling", e.MATERIAL_CEILING_CONCRETE = "kvad-material-ceiling-concrete", e.MATERIAL_CEILING_COLOR = "kvad-material-ceiling-color", e))(ws || {});
const vc = {
  [ne.WALL]: "kvad-materialcategory-wall",
  [ne.FLOOR]: "kvad-materialcategory-floor",
  [ne.CEILING]: "kvad-materialcategory-ceiling"
  /* MATERIALCATEGORY_CEILING */
};
var X = /* @__PURE__ */ ((e) => (e[e.INVALID_REFERENCE = 1] = "INVALID_REFERENCE", e[e.INVALID_ROOM_REFERENCE = 2] = "INVALID_ROOM_REFERENCE", e[e.INVALID_WALL_REFERENCE = 3] = "INVALID_WALL_REFERENCE", e[e.INVALID_FLOOR_REFERENCE = 4] = "INVALID_FLOOR_REFERENCE", e[e.INVALID_CEILING_REFERENCE = 5] = "INVALID_CEILING_REFERENCE", e[e.INVALID_WALL_FEATURE_REFERENCE = 6] = "INVALID_WALL_FEATURE_REFERENCE", e[e.INVALID_VIEWER_ID_REFERENCE = 7] = "INVALID_VIEWER_ID_REFERENCE", e[e.INVALID_CORNER_REFERENCE = 8] = "INVALID_CORNER_REFERENCE", e[e.UNSUPPORTED_WALL_FEATURE_TYPE = 9] = "UNSUPPORTED_WALL_FEATURE_TYPE", e[e.CEILING_HEIGHT_NOT_CONSTANT = 10] = "CEILING_HEIGHT_NOT_CONSTANT", e[e.WALLS_INTERSECTING = 11] = "WALLS_INTERSECTING", e[e.DELETE_CORNER_WALLS_INTERSECTING = 12] = "DELETE_CORNER_WALLS_INTERSECTING", e[e.WALL_RESIZE_EXCEED_MAX_VALUE = 13] = "WALL_RESIZE_EXCEED_MAX_VALUE", e[e.WALL_RESIZE_SAME_SIZE = 14] = "WALL_RESIZE_SAME_SIZE", e[e.WALL_COLLIDING_WITH_WALL_FEATURE = 15] = "WALL_COLLIDING_WITH_WALL_FEATURE", e[e.WALL_FEATURE_NO_AVAILABLE_FREE_SPACE = 16] = "WALL_FEATURE_NO_AVAILABLE_FREE_SPACE", e[e.WALL_FEATURE_OUT_OF_BOUNDS = 17] = "WALL_FEATURE_OUT_OF_BOUNDS", e[e.WALL_FEATURE_COLLIDING_WITH_CEILING = 18] = "WALL_FEATURE_COLLIDING_WITH_CEILING", e[e.WINDOW_COLLIDING_WITH_CEILING = 19] = "WINDOW_COLLIDING_WITH_CEILING", e[e.DOOR_COLLIDING_WITH_CEILING = 20] = "DOOR_COLLIDING_WITH_CEILING", e[e.WINDOW_COLLIDING_WITH_WALL = 21] = "WINDOW_COLLIDING_WITH_WALL", e[e.DOOR_COLLIDING_WITH_WALL = 22] = "DOOR_COLLIDING_WITH_WALL", e[e.WALL_FEATURE_COLLIDING_WITH_WALL_FEATURE = 23] = "WALL_FEATURE_COLLIDING_WITH_WALL_FEATURE", e[e.WALL_FEATURE_EXCEEDS_MINIMUM_VALUES = 24] = "WALL_FEATURE_EXCEEDS_MINIMUM_VALUES", e[e.CORNER_INSUFFICIENT_REMAINING = 25] = "CORNER_INSUFFICIENT_REMAINING", e[e.MISSING_CORNER_COMPONENTS = 26] = "MISSING_CORNER_COMPONENTS", e[e.MISSING_WALL_COMPONENTS = 27] = "MISSING_WALL_COMPONENTS", e[e.MISSING_EDGE_COMPONENTS = 28] = "MISSING_EDGE_COMPONENTS", e[e.NOT_IMPLEMENTED = 29] = "NOT_IMPLEMENTED", e[e.NO_UPDATE_REQUIRED = 30] = "NO_UPDATE_REQUIRED", e))(X || {});
const Sc = Object.freeze({
  23: "errorWallFeaturesColliding",
  11: "errorWallsIntersecting",
  18: "errorSomethingIsInTheWay",
  16: "errorNoAvailableFreeSpace",
  17: "errorSomethingIsInTheWay",
  19: "errorWindowCollidingWithCeiling",
  20: "errorDoorCollidingWithCeiling",
  21: "errorWindowCollidingWithWall",
  22: "errorDoorCollidingWithWall"
});
function Wc(e) {
  return e !== void 0 && e.type === ne.CEILING;
}
function wc(e) {
  return e !== void 0 && e.type === ne.FLOOR;
}
function zc(e) {
  return e !== void 0 && e.type === ne.WALL;
}
function bc(e) {
  return e !== void 0 && e.type === ne.CORNER;
}
function Uc(e) {
  return e !== void 0 && e.type === ne.WALL_FEATURE;
}
function Fc(e) {
  return e !== void 0 && Ie(e.entity);
}
function Gc(e) {
  return e !== void 0 && he(e.entity);
}
function Vc(e) {
  return e !== void 0 && [ne.WALL, ne.CEILING, ne.FLOOR].includes(e.type);
}
function zs(e) {
  return typeof e == "number" && typeof X[e] == "string";
}
class re {
  constructor() {
    m(this, "serializable", !1);
  }
}
const xn = /* @__PURE__ */ new Map(), to = {
  set(e, n) {
    if (to.has(e))
      throw new Error(`Deserializer for key ${e} already registered`);
    xn.set(e, n);
  },
  get(e) {
    const n = xn.get(e);
    if (n === void 0)
      throw new Error(`Deserializer for key ${e} not registered`);
    return n;
  },
  has(e) {
    return xn.has(e);
  }
}, j = (e, n) => to.set(e, n);
class z extends re {
  constructor() {
    super(...arguments);
    m(this, "serializable", !0);
    m(this, "doStoreInSnapshot", !0);
  }
  toJson(t) {
    const o = this.getSerializablePayload(), r = JSON.stringify(o, (s, i) => {
      if (!(s === "version" && i === 1))
        return i;
    });
    return t(r);
  }
  static dataFromJson(t) {
    const o = JSON.parse(t);
    return "version" in o || (o.version = 1), o;
  }
}
class oo extends z {
  constructor() {
    super(...arguments);
    m(this, "typeId", f.ROOM_CEILING_COMPONENT_ID);
  }
  eq() {
    return !0;
  }
  getSerializablePayload() {
    return { version: 1 };
  }
  serializationKey() {
    return "kv-ceiling";
  }
}
j("kv-ceiling", () => new oo());
function Bc(e) {
  return e.getComponent(f.ROOM_CEILING_COMPONENT_ID) ?? null;
}
function We(e) {
  return e.hasComponent(f.ROOM_CEILING_COMPONENT_ID);
}
function Hc(e) {
  e.removeComponent(f.ROOM_CEILING_COMPONENT_ID);
}
function kc(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_CEILING_COMPONENT_ID);
}
class In extends z {
  constructor(t, o) {
    super();
    m(this, "typeId", f.ROOM_CORNER_COMPONENT_ID);
    this.surfacePersistentIds = t, this.edgePersistentIds = o;
  }
  eq(t) {
    return _t(this.edgePersistentIds, t.edgePersistentIds).length === 0 && _t(this.surfacePersistentIds, t.surfacePersistentIds).length === 0;
  }
  getSerializablePayload() {
    return {
      surfacePersistentIds: this.surfacePersistentIds,
      edgePersistentIds: this.edgePersistentIds,
      version: 1
    };
  }
  serializationKey() {
    return "kv-corner";
  }
}
j("kv-corner", (e) => {
  const { surfacePersistentIds: n, edgePersistentIds: t } = z.dataFromJson(e);
  return new In(n, t);
});
function Ge(e) {
  return e.getComponent(f.ROOM_CORNER_COMPONENT_ID) ?? null;
}
function Ze(e) {
  return e.hasComponent(f.ROOM_CORNER_COMPONENT_ID);
}
function dn(e) {
  return w.localPosition(e);
}
function Kc(e) {
  return A.children(e).filter((n) => Ze(n));
}
function bs(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_CORNER_COMPONENT_ID);
}
function $c(e) {
  e.removeComponent(f.ROOM_CORNER_COMPONENT_ID);
}
class Us extends re {
  constructor(t, o) {
    super();
    m(this, "typeId", f.ROOM_CORNER_RELATION_COMPONENT_ID);
    m(this, "doStoreInSnapshot", !0);
    this.surfaces = t, this.edges = o;
  }
  eq(t) {
    return an(this.surfaces, t.surfaces, "id").length === 0 && an(this.edges, t.edges, "id").length === 0;
  }
}
function oe(e) {
  return e.getComponent(f.ROOM_CORNER_RELATION_COMPONENT_ID) ?? null;
}
function qc(e) {
  return e.hasComponent(f.ROOM_CORNER_RELATION_COMPONENT_ID);
}
function jc(e) {
  var n;
  return ((n = oe(e)) == null ? void 0 : n.edges.slice()) || [];
}
function Fs(e) {
  var n;
  return ((n = oe(e)) == null ? void 0 : n.surfaces.slice()) || [];
}
function Yc(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_CORNER_RELATION_COMPONENT_ID);
}
function Gs(e) {
  e.removeComponent(f.ROOM_CORNER_RELATION_COMPONENT_ID);
}
class ro extends z {
  constructor(t, o) {
    super();
    m(this, "typeId", f.ROOM_DOOR_COMPONENT_ID);
    this.doorType = t, this.handleLocation = o;
  }
  eq(t) {
    return this.doorType === t.doorType && this.handleLocation === t.handleLocation;
  }
  getSerializablePayload() {
    return { doorType: this.doorType, handleLocation: this.handleLocation, version: 1 };
  }
  serializationKey() {
    return "kv-door";
  }
}
j("kv-door", (e) => {
  const { doorType: n, handleLocation: t } = z.dataFromJson(e);
  return new ro(n, t);
});
function Vs(e) {
  return e.getComponent(f.ROOM_DOOR_COMPONENT_ID) ?? null;
}
function so(e) {
  return e.hasComponent(f.ROOM_DOOR_COMPONENT_ID);
}
function Bs(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_DOOR_COMPONENT_ID);
}
function Zc(e) {
  e.removeComponent(f.ROOM_DOOR_COMPONENT_ID);
}
class io extends z {
  constructor() {
    super(...arguments);
    m(this, "typeId", f.ROOM_EDGE_COMPONENT_ID);
  }
  eq() {
    return !0;
  }
  getSerializablePayload() {
    return { version: 1 };
  }
  serializationKey() {
    return "kv-edge";
  }
}
j("kv-edge", () => new io());
function Xc(e) {
  return e.getComponent(f.ROOM_EDGE_COMPONENT_ID) ?? null;
}
function ao(e) {
  return e.hasComponent(f.ROOM_EDGE_COMPONENT_ID);
}
function Hs(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_EDGE_COMPONENT_ID);
}
function Jc(e) {
  e.removeComponent(f.ROOM_EDGE_COMPONENT_ID);
}
class ks extends re {
  constructor(t, o, r, s) {
    super();
    m(this, "typeId", f.ROOM_EDGE_RELATION_COMPONENT_ID);
    m(this, "doStoreInSnapshot", !0);
    this.corner1 = t, this.corner2 = o, this.surface1 = r, this.surface2 = s;
  }
  get cornerPoint1() {
    return dn(this.corner1);
  }
  get cornerPoint2() {
    return dn(this.corner2);
  }
  eq(t) {
    return this.surface1.id === t.surface1.id && this.surface2.id === t.surface2.id && this.corner1.id === t.corner1.id && this.corner2.id === t.corner2.id;
  }
}
function J(e) {
  return e.getComponent(f.ROOM_EDGE_RELATION_COMPONENT_ID) ?? null;
}
function Ks(e) {
  return e.getComponentUnsafe(f.ROOM_EDGE_RELATION_COMPONENT_ID);
}
function Qc(e) {
  return e.hasComponent(f.ROOM_EDGE_RELATION_COMPONENT_ID);
}
function el(e) {
  const n = J(e);
  if (!n)
    return null;
  const t = n.cornerPoint1, o = n.cornerPoint2;
  return !t || !o ? null : [t, o];
}
function nl(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_EDGE_RELATION_COMPONENT_ID);
}
function $s(e) {
  e.removeComponent(f.ROOM_EDGE_RELATION_COMPONENT_ID);
}
class tl extends re {
  constructor() {
    super(...arguments);
    m(this, "typeId", f.EXCLUDE_WALL_FEATURE_FROM_BLUEPRINT_COMPONENT_ID);
    m(this, "doStoreInSnapshot", !1);
  }
  eq() {
    return !0;
  }
}
function qs(e) {
  return e.hasComponent(f.EXCLUDE_WALL_FEATURE_FROM_BLUEPRINT_COMPONENT_ID);
}
function ol(e) {
  e.removeComponent(f.EXCLUDE_WALL_FEATURE_FROM_BLUEPRINT_COMPONENT_ID);
}
class co extends z {
  constructor() {
    super(...arguments);
    m(this, "typeId", f.ROOM_FLOOR_COMPONENT_ID);
  }
  eq() {
    return !0;
  }
  getSerializablePayload() {
    return { version: 1 };
  }
  serializationKey() {
    return "kv-floor";
  }
}
j("kv-floor", () => new co());
function rl(e) {
  return e.getComponent(f.ROOM_FLOOR_COMPONENT_ID) ?? null;
}
function Ce(e) {
  return e.hasComponent(f.ROOM_FLOOR_COMPONENT_ID);
}
function sl(e) {
  return A.children(e).find((n) => Ce(n)) ?? null;
}
function il(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_FLOOR_COMPONENT_ID);
}
function al(e) {
  e.removeComponent(f.ROOM_FLOOR_COMPONENT_ID);
}
class pn extends z {
  constructor() {
    super(...arguments);
    m(this, "typeId", f.KVADRAT_COMPONENT_ID);
  }
  eq() {
    return !0;
  }
  getSerializablePayload() {
    return { version: 1 };
  }
  serializationKey() {
    return "kv-kvadrat";
  }
}
j("kv-kvadrat", () => new pn());
function js(e) {
  return e.hasComponent(f.KVADRAT_COMPONENT_ID);
}
function we(e) {
  return A.getDescendantsWithComponent(e, f.KVADRAT_COMPONENT_ID);
}
function cl(e) {
  e.removeComponent(f.KVADRAT_COMPONENT_ID);
}
const k = [];
for (let e = 0; e < 256; ++e)
  k.push((e + 256).toString(16).slice(1));
function Ys(e, n = 0) {
  return (k[e[n + 0]] + k[e[n + 1]] + k[e[n + 2]] + k[e[n + 3]] + "-" + k[e[n + 4]] + k[e[n + 5]] + "-" + k[e[n + 6]] + k[e[n + 7]] + "-" + k[e[n + 8]] + k[e[n + 9]] + "-" + k[e[n + 10]] + k[e[n + 11]] + k[e[n + 12]] + k[e[n + 13]] + k[e[n + 14]] + k[e[n + 15]]).toLowerCase();
}
let yn;
const Zs = new Uint8Array(16);
function Xs() {
  if (!yn) {
    if (typeof crypto > "u" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    yn = crypto.getRandomValues.bind(crypto);
  }
  return yn(Zs);
}
const Js = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), Lt = { randomUUID: Js };
function bn(e, n, t) {
  if (Lt.randomUUID && !n && !e)
    return Lt.randomUUID();
  e = e || {};
  const o = e.random || (e.rng || Xs)();
  return o[6] = o[6] & 15 | 64, o[8] = o[8] & 63 | 128, Ys(o);
}
class et extends z {
  constructor(t) {
    super();
    m(this, "typeId", f.KVADRAT_LOCAL_COMPONENT_ID);
    this.id = t;
  }
  eq(t) {
    return this.id === t.id;
  }
  getSerializablePayload() {
    return { id: this.id, version: 1 };
  }
  serializationKey() {
    return "kv-id";
  }
}
j("kv-id", (e) => {
  const { id: n } = z.dataFromJson(e);
  return new et(n);
});
function Ne(e) {
  return e.getComponent(f.KVADRAT_LOCAL_COMPONENT_ID) ?? null;
}
function ll(e) {
  return e.hasComponent(f.KVADRAT_LOCAL_COMPONENT_ID);
}
function Re(e = bn(), n) {
  return n.addComponent(new et(e)), e;
}
const lo = (e) => {
  var n;
  return (n = Ne(e)) == null ? void 0 : n.id;
}, ul = (e) => e.map(lo), fe = (e) => {
  const n = lo(e);
  if (n === void 0)
    throw new Error(`Entity with ID ${e.id} does not have a Kvadrat ID component`);
  return n;
}, Ve = (e) => e.map(fe);
function dl(e) {
  e.removeComponent(f.KVADRAT_LOCAL_COMPONENT_ID);
}
class on extends z {
  constructor(t) {
    super();
    m(this, "typeId", f.ROOM_MATERIAL_COMPONENT_ID);
    this.material = t;
  }
  eq(t) {
    return On(this.material, t.material);
  }
  getSerializablePayload() {
    return {
      id: this.material.id,
      colorCode: this.material.colorCode,
      url: this.material.url,
      previewUrl: this.material.previewUrl,
      version: 1
    };
  }
  serializationKey() {
    return "kv-material";
  }
}
j("kv-material", (e) => {
  const { id: n, url: t, previewUrl: o, colorCode: r } = z.dataFromJson(e);
  return new on({
    id: n,
    url: t,
    previewUrl: o,
    colorCode: r
  });
});
function Qs(e) {
  return e.getComponent(f.ROOM_MATERIAL_COMPONENT_ID) ?? null;
}
function fl(e) {
  return e.hasComponent(f.ROOM_MATERIAL_COMPONENT_ID);
}
function Ol(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_MATERIAL_COMPONENT_ID);
}
function hl(e) {
  e.removeComponent(f.ROOM_MATERIAL_COMPONENT_ID);
}
class El extends re {
  constructor(t) {
    super();
    m(this, "typeId", f.ROOM_MATERIAL_PREVIEW_COMPONENT_ID);
    m(this, "doStoreInSnapshot", !1);
    this.material = t;
  }
  eq(t) {
    return On(this.material, t.material);
  }
}
function ei(e) {
  return e.getComponent(f.ROOM_MATERIAL_PREVIEW_COMPONENT_ID) ?? null;
}
function _l(e) {
  return e.hasComponent(f.ROOM_MATERIAL_PREVIEW_COMPONENT_ID);
}
function Il(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_MATERIAL_PREVIEW_COMPONENT_ID);
}
function pl(e) {
  e.removeComponent(f.ROOM_MATERIAL_PREVIEW_COMPONENT_ID);
}
class uo extends re {
  constructor(t = {}) {
    super();
    m(this, "typeId", f.ROOM_MATERIAL_STORAGE_COMPONENT_ID);
    m(this, "doStoreInSnapshot", !0);
    this.storage = t;
  }
  eq(t) {
    return On(t, this);
  }
}
function ni(e) {
  return e.getComponent(f.ROOM_MATERIAL_STORAGE_COMPONENT_ID) ?? null;
}
function gl(e) {
  return e.hasComponent(f.ROOM_MATERIAL_STORAGE_COMPONENT_ID);
}
function Nl(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_MATERIAL_STORAGE_COMPONENT_ID);
}
function Cl(e) {
  e.removeComponent(f.ROOM_MATERIAL_STORAGE_COMPONENT_ID);
}
class ti extends re {
  constructor() {
    super(...arguments);
    m(this, "typeId", f.OPENING_ARC_COMPONENT_ID);
    m(this, "doStoreInSnapshot", !0);
  }
  eq() {
    return !1;
  }
}
function oi(e) {
  return e.hasComponent(f.OPENING_ARC_COMPONENT_ID);
}
function ml(e) {
  return e.getComponent(f.OPENING_ARC_COMPONENT_ID) ?? null;
}
function Rl(e) {
  e.removeComponent(f.OPENING_ARC_COMPONENT_ID);
}
class fo extends z {
  constructor(t) {
    super();
    m(this, "typeId", f.OPENING_DIRECTION_COMPONENT_ID);
    this.openingDirection = t;
  }
  eq(t) {
    return this.openingDirection === t.openingDirection;
  }
  getSerializablePayload() {
    return { openingDirection: this.openingDirection, version: 1 };
  }
  serializationKey() {
    return "kv-opening-direction";
  }
}
j("kv-opening-direction", (e) => {
  const { openingDirection: n } = z.dataFromJson(e);
  return new fo(n);
});
function ri(e) {
  return e.getComponent(f.OPENING_DIRECTION_COMPONENT_ID) ?? null;
}
function si(e) {
  return e.hasComponent(f.OPENING_DIRECTION_COMPONENT_ID);
}
function Ml(e) {
  e.removeComponent(f.OPENING_DIRECTION_COMPONENT_ID);
}
class nt extends z {
  constructor(t) {
    super();
    m(this, "typeId", f.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID);
    this.size = t;
  }
  eq(t) {
    return this.size.vector.equals(t.size.vector);
  }
  getSerializablePayload() {
    return {
      size: { X: this.size.width, Y: this.size.height, Z: this.size.depth },
      version: 1
    };
  }
  serializationKey() {
    return "kv-parametric-object";
  }
}
j("kv-parametric-object", (e) => {
  const { size: n } = z.dataFromJson(e);
  return new nt(new Bn(n.X, n.Y, n.Z));
});
function tt(e) {
  return e.getComponent(f.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID) ?? null;
}
function Oo(e) {
  return e.hasComponent(f.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID);
}
function ii(e) {
  return A.children(e).filter((n) => Oo(n));
}
function Tl(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID);
}
function Al(e) {
  e.removeComponent(f.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID);
}
class ho extends z {
  constructor() {
    super(...arguments);
    m(this, "typeId", f.ROOM_COMPONENT_ID);
  }
  eq() {
    return !0;
  }
  getSerializablePayload() {
    return { version: 1 };
  }
  serializationKey() {
    return "kv-room";
  }
}
j("kv-room", () => new ho());
function Dl(e) {
  return e.getComponent(f.ROOM_COMPONENT_ID) ?? null;
}
function xt(e) {
  return e.hasComponent(f.ROOM_COMPONENT_ID);
}
function ai(e) {
  return A.getDescendantWithComponent(e, f.ROOM_COMPONENT_ID) ?? null;
}
function Ll(e) {
  e.removeComponent(f.ROOM_COMPONENT_ID);
}
class ot extends z {
  constructor(t) {
    super();
    m(this, "typeId", f.ROOM_SURFACE_COMPONENT_ID);
    this.cornerPersistentIds = t;
  }
  eq(t) {
    return On(this.cornerPersistentIds, t.cornerPersistentIds);
  }
  getSerializablePayload() {
    return { cornerPersistentIds: [...this.cornerPersistentIds], version: 1 };
  }
  serializationKey() {
    return "kv-surface";
  }
}
j("kv-surface", (e) => {
  const { cornerPersistentIds: n } = z.dataFromJson(e);
  return new ot(n);
});
function rt(e) {
  return e.getComponent(f.ROOM_SURFACE_COMPONENT_ID) ?? null;
}
function Un(e) {
  return e.hasComponent(f.ROOM_SURFACE_COMPONENT_ID);
}
function ci(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_SURFACE_COMPONENT_ID);
}
function xl(e) {
  e.removeComponent(f.ROOM_SURFACE_COMPONENT_ID);
}
const $e = (e) => !!e;
class li extends re {
  constructor(t, o) {
    super();
    m(this, "typeId", f.ROOM_SURFACE_RELATIONS_COMPONENT_ID);
    m(this, "doStoreInSnapshot", !0);
    this.corners = t, this.edges = o;
  }
  get cornerPoints() {
    return this.corners.map(dn).filter($e);
  }
  eq(t) {
    return an(this.corners, t.corners, "id").length === 0 && an(this.edges, t.edges, "id").length === 0;
  }
}
function ce(e) {
  return e.getComponent(f.ROOM_SURFACE_RELATIONS_COMPONENT_ID) ?? null;
}
function Fn(e) {
  return e.getComponentUnsafe(f.ROOM_SURFACE_RELATIONS_COMPONENT_ID);
}
function yl(e) {
  return e.hasComponent(f.ROOM_SURFACE_RELATIONS_COMPONENT_ID);
}
function Pl(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_SURFACE_RELATIONS_COMPONENT_ID);
}
function ui(e) {
  e.removeComponent(f.ROOM_SURFACE_RELATIONS_COMPONENT_ID);
}
class Eo extends re {
  constructor() {
    super(...arguments);
    m(this, "typeId", f.ROOM_UNDER_CONSTRUCTION_COMPONENT_ID);
    m(this, "doStoreInSnapshot", !1);
  }
  eq() {
    return !0;
  }
}
function vl(e) {
  return e.getComponent(f.ROOM_UNDER_CONSTRUCTION_COMPONENT_ID) ?? null;
}
function pe(e) {
  return e.hasComponent(f.ROOM_UNDER_CONSTRUCTION_COMPONENT_ID);
}
function Sl(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_UNDER_CONSTRUCTION_COMPONENT_ID);
}
function di(e) {
  e.removeComponent(f.ROOM_UNDER_CONSTRUCTION_COMPONENT_ID);
}
class st extends re {
  constructor(t, o) {
    super();
    m(this, "typeId", f.SHOULD_BE_INTERACTABLE_COMPONENT_ID);
    m(this, "doStoreInSnapshot", !0);
    this.draggable = t, this.selectable = o;
  }
  eq(t) {
    return this.draggable === t.draggable && this.selectable === t.selectable;
  }
}
function Wl(e) {
  return e.getComponent(f.SHOULD_BE_INTERACTABLE_COMPONENT_ID) ?? null;
}
function wl(e) {
  return e.hasComponent(f.SHOULD_BE_INTERACTABLE_COMPONENT_ID);
}
function zl(e) {
  return A.getDescendantsWithComponent(e, f.SHOULD_BE_INTERACTABLE_COMPONENT_ID);
}
function bl(e) {
  e.removeComponent(f.SHOULD_BE_INTERACTABLE_COMPONENT_ID);
}
class fi extends z {
  constructor(t, o) {
    super();
    m(this, "typeId", f.ROOM_SLOPED_CEILING_COMPONENT_ID);
    this.height = t, this.depth = o;
  }
  eq(t) {
    return this.height === t.height && this.depth === t.depth;
  }
  getSerializablePayload() {
    return {
      height: this.height,
      depth: this.depth,
      version: 1
    };
  }
  serializationKey() {
    return "kv-sloped-ceiling";
  }
}
j("kv-sloped-ceiling", (e) => {
  const { height: n, depth: t } = z.dataFromJson(e);
  return new fi(n, t);
});
function Ul(e) {
  return e.getComponent(f.ROOM_SLOPED_CEILING_COMPONENT_ID) ?? null;
}
function Fl(e) {
  return e.hasComponent(f.ROOM_SLOPED_CEILING_COMPONENT_ID);
}
function Gl(e) {
  e.removeComponent(f.ROOM_SLOPED_CEILING_COMPONENT_ID);
}
class Oi extends re {
  constructor(t, o) {
    super();
    m(this, "typeId", f.SURFACE_RESIZING_COMPONENT_ID);
    m(this, "doStoreInSnapshot", !1);
    this.sizeChange = t, this.centerMoveDirection = o;
  }
  eq(t) {
    return this.sizeChange.equals(t.sizeChange) && this.centerMoveDirection.equals(t.centerMoveDirection);
  }
}
function Vl(e) {
  return e.getComponent(f.SURFACE_RESIZING_COMPONENT_ID) ?? null;
}
function Bl(e) {
  return e.hasComponent(f.SURFACE_RESIZING_COMPONENT_ID);
}
function hi(e) {
  e.removeComponent(f.SURFACE_RESIZING_COMPONENT_ID);
}
class _o extends z {
  constructor() {
    super(...arguments);
    m(this, "typeId", f.ROOM_WALL_COMPONENT_ID);
  }
  eq() {
    return !0;
  }
  getSerializablePayload() {
    return { version: 1 };
  }
  serializationKey() {
    return "kv-wall";
  }
}
j("kv-wall", () => new _o());
function ze(e) {
  return e.hasComponent(f.ROOM_WALL_COMPONENT_ID);
}
function Hl(e) {
  return e.getComponent(f.ROOM_WALL_COMPONENT_ID) ?? null;
}
function kl(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_WALL_COMPONENT_ID);
}
function Kl(e) {
  e.removeComponent(f.ROOM_WALL_COMPONENT_ID);
}
class Io extends z {
  constructor(t, o) {
    super();
    m(this, "typeId", f.ROOM_WINDOW_COMPONENT_ID);
    this.windowType = t, this.handleLocation = o;
  }
  eq(t) {
    return this.windowType === t.windowType && this.handleLocation === t.handleLocation;
  }
  getSerializablePayload() {
    return { windowType: this.windowType, handleLocation: this.handleLocation, version: 1 };
  }
  serializationKey() {
    return "kv-window";
  }
}
j("kv-window", (e) => {
  const { windowType: n, handleLocation: t } = z.dataFromJson(e);
  return new Io(n, t);
});
function Ei(e) {
  return e.getComponent(f.ROOM_WINDOW_COMPONENT_ID) ?? null;
}
function gn(e) {
  return e.hasComponent(f.ROOM_WINDOW_COMPONENT_ID);
}
function _i(e) {
  return A.getDescendantsWithComponent(e, f.ROOM_WINDOW_COMPONENT_ID);
}
function $l(e) {
  e.removeComponent(f.ROOM_WINDOW_COMPONENT_ID);
}
function Ii(e) {
  return typeof e.center == "function";
}
function ql(e) {
  return Array.isArray(e.collisions);
}
function jl(e) {
  return Array.isArray(e.unfulfilledConnectors);
}
const pi = 0.0174532925;
function Yl(e, n) {
  const t = n.x - e.x, o = n.y - e.y;
  return Math.atan2(o, t);
}
function Ue(e) {
  return C(e.x, e.z);
}
function _e({ X: e, Y: n, Z: t }) {
  return O(e, n, t);
}
function po({ width: e, height: n, depth: t }) {
  return new Bn(e, n, t);
}
function yt({ x: e, y: n, z: t }) {
  return new Z(e, n, t);
}
function Zl(e, n, t) {
  return gi(Ue(e), n, t);
}
function gi(e, n, t) {
  return cn.add(n, cn.muls(e, t));
}
function Xl(e, n) {
  return cn.normalize(cn.sub(n, e));
}
function Gn(e, n) {
  return V(e, me(K(n, e), 2));
}
function Jl(e, n) {
  return Math.sqrt(e * e + n * n);
}
function Ql(e, n) {
  return n = Math.pow(10, n), Math.round(e * n) / n;
}
function eu(e) {
  let n = Number.MIN_SAFE_INTEGER, t = Number.MIN_SAFE_INTEGER, o = Number.MAX_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER;
  return e.forEach((s) => {
    n = Math.max(s.x, n), t = Math.max(s.y, t), o = Math.min(s.x, o), r = Math.min(s.y, r);
  }), {
    min: { x: o, y: r },
    max: { x: n, y: t }
  };
}
function nu(e) {
  if (!e)
    return;
  const { corners: n } = e;
  let t = n.length, o = 0, r = t - 1;
  for (let s = 0; s < t; s++)
    o += (n[r].x + n[s].x) * (n[r].z - n[s].z), r = s;
  return Math.abs(o / 2e6);
}
function go(e, n) {
  let t;
  if (e)
    do
      t = `${n}${bn()}`;
    while (e.includes(t));
  else
    t = `${n}${bn()}`;
  return t;
}
function Pt(e, n) {
  return e > n ? e - 1 : e;
}
function Vn(e, n = pi / 10) {
  return Math.abs(e) < n;
}
function tu(e, n, t) {
  const o = Math.sqrt(Math.pow(n.x - e.x, 2) + Math.pow(n.y - e.y, 2)), r = t / o, s = (1 - r) * e.x + r * n.x, i = (1 - r) * e.y + r * n.y;
  return {
    x: s,
    y: i
  };
}
function Ni(e) {
  return {
    materials: {},
    metadata: {},
    rooms: [],
    ...e,
    versionMajor: Yn,
    versionMinor: Zn
  };
}
function ou(e, n = new Z(0, 0, 0), t) {
  const o = e.height, r = [
    {
      id: "back-wall",
      leftIndex: 0,
      rightIndex: 1,
      height: o
    },
    {
      id: "right-wall",
      leftIndex: 1,
      rightIndex: 2,
      height: o
    },
    {
      id: "front-wall",
      leftIndex: 2,
      rightIndex: 3,
      height: o
    },
    {
      id: "left-wall",
      leftIndex: 3,
      rightIndex: 0,
      height: o
    }
  ], s = e.width / 2, i = e.depth / 2;
  return {
    ...jr(),
    materials: or(t, "id"),
    rooms: [
      {
        corners: [
          {
            id: "corner-1",
            ..._e(new Z(-s, 0, -i).plus(n.x0z()))
          },
          {
            id: "corner-2",
            ..._e(new Z(s, 0, -i).plus(n.x0z()))
          },
          {
            id: "corner-3",
            ..._e(new Z(s, 0, i).plus(n.x0z()))
          },
          {
            id: "corner-4",
            ..._e(new Z(-s, 0, i).plus(n.x0z()))
          }
        ],
        walls: r,
        floors: [],
        ceilings: []
      }
    ]
  };
}
function ru(e) {
  const { rooms: n } = e;
  if (!n || !n.length)
    throw new Error("Blueprint didn't have any rooms");
  const { corners: t } = n[0], o = O(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE), r = O(Number.MIN_VALUE, Number.MIN_VALUE, Number.MIN_VALUE);
  for (const s of t)
    o.x = Math.min(o.x, s.x), r.x = Math.max(r.x, s.x), o.z = Math.min(o.z, s.z), r.z = Math.max(r.z, s.z);
  for (const s of n[0].walls) {
    const i = t[s.leftIndex], a = t[s.rightIndex];
    if (Se(s.height))
      o.y = Math.min(o.y, i.y, a.y), r.y = Math.max(r.y, i.y + s.height, a.y + s.height);
    else
      throw new Error("Room type not supported");
  }
  return {
    min: o,
    max: r,
    width: r.x - o.x,
    height: r.y - o.y,
    depth: r.z - o.z
  };
}
function Ci(e, n, t) {
  const o = [...e || []];
  return o.splice(n, 1, t), o;
}
function su(e, n, t) {
  const o = e.findIndex((r) => r.id === n);
  return Ci(e, o, t);
}
function it(e, n) {
  let t = 0;
  for (const o of e) {
    const r = n(o, e, t++);
    if (r)
      return r;
  }
  return !1;
}
const No = 300, mi = 100, Co = [No, mi, 0];
function iu(e) {
  return e.flatMap((n) => n.walls).flatMap((n) => n.features).map((n) => n == null ? void 0 : n.id).filter(Boolean);
}
function au(e) {
  return e.flatMap((n) => n.walls).map((n) => n.id).filter(Boolean);
}
function mo(e, n) {
  const t = Nn(e, n), o = e.floors.map((s, i) => ({
    ...s,
    index: i,
    material: s.materialId ? n[s.materialId] : void 0
  })), r = e.ceilings.map((s, i) => ({
    ...s,
    index: i,
    material: s.materialId ? n[s.materialId] : void 0
  }));
  return {
    corners: e.corners,
    walls: t,
    invalidWalls: Mo(t),
    floors: o,
    ceilings: r
  };
}
function Nn(e, n) {
  const t = [], o = {}, r = [];
  for (let [i, a] of e.walls.entries()) {
    const c = Mi(i, a, e.corners, n);
    r.push(c), o[c.leftIndex] || (o[c.leftIndex] = {}), o[c.leftIndex].left = c, o[c.rightIndex] || (o[c.rightIndex] = {}), o[c.rightIndex].right = c;
  }
  for (let i in o) {
    const a = o[i];
    a.crossProduct = Ri(a.right, a.left), a.innerCorner = a.right && a.left && a.crossProduct > 0;
  }
  const s = r;
  for (let i of s)
    i.previousWall = o[i.leftIndex].right, i.previousWallAngle = o[i.leftIndex].crossProduct, i.checkForLeftCollision = o[i.leftIndex].innerCorner, i.nextWall = o[i.rightIndex].left, i.nextWallAngle = o[i.rightIndex].crossProduct, i.checkForRightCollision = o[i.rightIndex].innerCorner;
  if (s.length) {
    const [i] = s;
    let a = i;
    do
      t.push(a), a = a.nextWall;
    while (a !== i);
  }
  return t;
}
function Ri(e, n) {
  let t = 0;
  return e.p2.x == n.p1.x && e.p2.z == n.p1.z ? t = Oe(e.direction, n.direction).y : t = Oe(n.direction, e.direction).y, t;
}
function Mi(e, n, t, o) {
  var l;
  const r = t[n.leftIndex], s = t[n.rightIndex], i = K(s, r), a = te(i), c = (l = n.features) == null ? void 0 : l.map((u, d) => {
    const h = {
      ...r,
      ...V(r, b(a, u.positionAlongWall))
    }, I = {
      ...s,
      ...V(r, b(a, u.positionAlongWall + u.size.width))
    };
    return {
      ...u,
      wallIndex: e,
      wallId: n.id,
      featureIndex: d,
      direction: a,
      p1: h,
      p2: I,
      center: Gn(h, I)
    };
  });
  return {
    ...n,
    index: e,
    p1: r,
    p2: s,
    direction: a,
    length: B(i),
    center: Gn(r, s),
    features: c,
    material: n.materialId ? o[n.materialId] : void 0
  };
}
function cu(e) {
  const n = [];
  let o = Nn(e, {})[0];
  for (; !n.includes(o); )
    n.push(o), o = o.nextWall;
  return n;
}
function Ti(e, n) {
  const t = e.p1.x - n.p1.x, o = e.p1.z - n.p1.z;
  return t < 0 || t === 0 && o <= 0 ? -1 : 1;
}
function Ai(e, n) {
  const t = e.p2.x - n.p2.x, o = e.p1.z - n.p1.z;
  return t < 0 || t === 0 && o >= 0 ? -1 : 1;
}
function Di(e) {
  const n = ve(e.direction), t = n <= -Math.PI / 4 * 3 && n <= -Math.PI, o = n >= Math.PI / 4 * 3 && n <= Math.PI;
  return !!(t || o);
}
function Li(e) {
  const n = ve(e.direction), t = n >= -Math.PI / 4 && n <= 0, o = n >= 0 && n <= Math.PI / 4;
  return !!(t || o);
}
function lu(e, n) {
  if (!n.length)
    return;
  const [t = n[0]] = n.filter(Di).sort(Ai);
  if (!t)
    return;
  let o = t;
  do {
    const r = (o.length - e.size.width) / 2, { features: s = [] } = o;
    if (!(e.size.width + No * 2 < o.length)) {
      o = o.nextWall;
      continue;
    }
    if (!s.length)
      return {
        wall: o,
        positionAlongWall: r
      };
    if (!s.some(Ie)) {
      const c = {
        ...e,
        positionAlongWall: r
      };
      if (!s.some((u) => at(c, u)))
        return {
          wall: o,
          positionAlongWall: r
        };
    }
    o = o.nextWall;
  } while (o !== t);
  for (let r of Co) {
    const s = Ro(t, r, e);
    if (s)
      return s;
  }
}
function uu(e, n) {
  if (!n.length)
    return;
  const [t = n[0]] = n.filter(Li).sort(Ti);
  if (t)
    for (let o of Co) {
      const r = Ro(t, o, e);
      if (r)
        return r;
    }
}
function Ro(e, n, t) {
  let o = e;
  do {
    const r = xi(o, n, t);
    if (r >= 0)
      return {
        wall: o,
        positionAlongWall: r
      };
    o = o.nextWall;
  } while (o !== e);
}
function xi(e, n, t) {
  const o = n * 2;
  if (!e.features || e.features.length === 0)
    return e.length - o < t.size.width ? -1 : n;
  for (let i = 0; i < e.features.length; i++) {
    const a = e.features[i], c = e.features[i - 1], l = c ? c.positionAlongWall + c.size.width + n : n;
    if (a.positionAlongWall - l - n >= t.size.width)
      return l;
  }
  const r = e.features[e.features.length - 1], s = r.positionAlongWall + r.size.width + n;
  return e.length - s - n >= t.size.width ? s : -1;
}
function du(e) {
  return it(e, yi);
}
function yi(e) {
  return Pi(e) || vi(e);
}
function Pi(e) {
  return it(e.walls, (n) => Wi(n, e.corners));
}
function vi(e) {
  return Mo(e.walls).length > 0 ? X.WALLS_INTERSECTING : !1;
}
function fu(e, n) {
  if (!n)
    return e.positionAlongWall;
  const o = (n.features || []).filter(
    (a) => at(a, e)
  );
  if (!o.length)
    return e.positionAlongWall;
  const [{ wallFeature: r }] = o.map((a) => {
    const c = Math.max(a.positionAlongWall, e.positionAlongWall);
    return {
      overlappingSize: Math.min(
        a.positionAlongWall + a.size.width,
        e.positionAlongWall + e.size.width
      ) - c,
      wallFeature: a
    };
  }).sort((a, c) => a.overlappingSize - c.overlappingSize), s = e.positionAlongWall + e.size.width / 2, i = r.positionAlongWall + r.size.width / 2;
  return s < i ? r.positionAlongWall - e.size.width : r.positionAlongWall + r.size.width;
}
function Si(e) {
  const n = he(e) && ys || Ie(e) && vs || e.size.width, t = he(e) && Ps || Ie(e) && Ss || e.size.width;
  if (e.size.width < n || e.size.height < t)
    return X.WALL_FEATURE_EXCEEDS_MINIMUM_VALUES;
}
function Wi(e, n) {
  if (!e.features || e.features.length === 0)
    return !1;
  const t = n[e.leftIndex], o = n[e.rightIndex], r = B(K(o, t)), s = e.features[0], i = e.features[e.features.length - 1];
  if (s.positionAlongWall < 0 || i.positionAlongWall + i.size.width > r)
    return X.WALL_FEATURE_OUT_OF_BOUNDS;
  let a;
  return it(e.features, (c, l, u) => (a = l[u + 1], Si(c) || wi(c, e.height) || at(c, a)));
}
function wi(e, n) {
  return he(e) ? e.size.height + e.groundClearance > n ? X.WALL_FEATURE_COLLIDING_WITH_CEILING : !1 : Ie(e) ? e.size.height > n ? X.WALL_FEATURE_COLLIDING_WITH_CEILING : !1 : X.INVALID_WALL_FEATURE_REFERENCE;
}
function at(e, n) {
  if (!e || !n)
    return !1;
  const [t, o] = [e, n].sort(_n());
  return t.positionAlongWall + t.size.width > o.positionAlongWall && X.WALL_FEATURE_COLLIDING_WITH_WALL_FEATURE;
}
function Mo(e) {
  return e.filter((n, t) => {
    for (let o = 0; o < e.length; o++) {
      if (o === t)
        continue;
      const r = e[o], s = {
        p1: Ue(n.p1),
        p2: Ue(n.p2)
      }, i = {
        p1: Ue(r.p1),
        p2: Ue(r.p2)
      }, a = zi(n, r);
      if (Ur(s, i, a))
        return !0;
    }
    return !1;
  });
}
function zi(e, n, t = !0) {
  return !!(e.nextWall === n || e.previousWall === n || t && e.nextWall.length < 1 && e.nextWall.nextWall === n || t && e.previousWall.length < 1 && e.previousWall.previousWall === n);
}
function Ou(e, n, t) {
  if (!e.features || e.features.length === 0)
    return e;
  const o = B(K(n[e.rightIndex], n[e.leftIndex])), s = B(K(t[e.rightIndex], t[e.leftIndex])) - o;
  return {
    ...e,
    features: e.features.map((i) => ({
      ...i,
      // positionAlongWall: round(feature.positionAlongWall + diff, 5),
      positionAlongWall: i.positionAlongWall + s
    }))
  };
}
function hu(e, n, t, o) {
  const r = [...e], s = r.findIndex(
    (i, a, c) => n === i && t === c[a + 1]
  );
  return r.splice(s + 1, 0, o - 1), r;
}
function Eu(e, n = 0) {
  const t = e[n];
  let o = [];
  for (let r = 0, s = t.walls[0]; r < t.walls.length; r++, s = s.nextWall)
    !Be(s.p1, s.previousWall.p1, s.p2) && (!Be(s.nextWall.p1, s.p1, s.nextWall.p2) || !Be(s.previousWall.p1, s.p1, s.nextWall.p2)) && o.push({
      id: s.id,
      leftIndex: s.leftIndex,
      rightIndex: s.rightIndex,
      height: s.height,
      features: s.features
    });
  return o;
}
function Be(e, n, t) {
  return Br(ln(e, n, t), Math.PI / 2);
}
function _u(e, n) {
  return n === no.RIGHT ? Be(e.p2, e.p1, e.nextWall.p2) : Be(e.p1, e.previousWall.p1, e.p2);
}
function Iu(e, n, t) {
  const o = [...e.features || []];
  let r = n.featureIndex;
  n.featureIndex < 0 && (o.push(n), o.sort(_n()), r = o.findIndex((i) => i === n));
  const s = o.length;
  return t === eo.LEFT ? r === 0 ? e.p1 : o[r - 1].p2 : r === s - 1 ? e.p2 : o[r + 1].p1;
}
function pu(e, n) {
  Vn(e.previousWallAngle) && n(e.previousWall.id, e.p1, !1), Vn(e.nextWallAngle) && n(e.nextWall.id, e.p2, !1);
}
function gu(e, n) {
  return {
    ...e,
    leftIndex: Pt(e.leftIndex, n),
    rightIndex: Pt(e.rightIndex, n)
  };
}
function bi(e, n) {
  let t;
  return e.forEach((o) => {
    var l, u, d;
    const r = n[o.leftIndex], s = n[o.rightIndex], i = B(K(s, r)), a = (l = o.features) == null ? void 0 : l[0], c = (d = o.features) == null ? void 0 : d[((u = o.features) == null ? void 0 : u.length) - 1];
    !a || !c || (a.positionAlongWall < 1 && (t = a.id), c.positionAlongWall + c.size.width > i - 1 && (t = c.id));
  }), t;
}
function Nu(e, n, t, o, r) {
  if (!zs(e))
    return;
  const { setInvalidatedCollidableId: s } = o, { onNotification: i } = n;
  switch (e) {
    case X.CORNER_INSUFFICIENT_REMAINING:
      i.emit({
        type: "info",
        title: t("notificationTitleCorner"),
        message: t("notificationMessageCornersMinimumLimitExceeded")
      });
      break;
    case X.WALL_FEATURE_OUT_OF_BOUNDS:
      i.emit({
        type: "error",
        title: t("notificationTitleWallFeature"),
        message: t("notificationMessageWallFeatureBlocking")
      }), s(bi(r.walls, r.corners));
      break;
    case X.WALLS_INTERSECTING:
      i.emit({
        type: "error",
        title: t("notificationTitleCornersIntersecting"),
        message: t("notificationMessageWallsIntersecting")
      });
      break;
    case X.DELETE_CORNER_WALLS_INTERSECTING:
      i.emit({
        type: "info",
        title: t("notificationTitleCornersIntersecting"),
        message: t("notificationMessageCornersIntersecting")
      });
      break;
  }
}
function Cu(e, n) {
  if (parseFloat(n) < 1.1)
    throw new Error(`ICF version ${n} not supported`);
  if (!e.rooms.length)
    return {
      floors: [],
      doors: [],
      obstacles: [],
      walls: [],
      windows: []
    };
  const t = mo(e.rooms[0], {}), o = {
    floors: [],
    // "{List[Surface]} List of floor polygons",
    walls: [],
    // "{List[Surface]} List of wall polygons",
    doors: [],
    // "{List[Bounds]} List of door bounding boxes",
    windows: [],
    // "{List[Bounds]} List of windows bounding boxes",
    obstacles: []
    // "{List[Bounds]} List of obstacle bounding boxes"
  }, r = {
    x: 0,
    y: 0,
    z: 0
  };
  o.walls = t.walls.map((i) => ({
    id: i.id,
    points: [
      i.p1,
      i.p2,
      V(i.p2, {
        ...r,
        y: +i.height
      }),
      V(i.p1, {
        ...r,
        y: +i.height
      })
    ]
  }));
  const s = t.walls.map(({ leftIndex: i }) => {
    const { x: a, y: c, z: l } = t.corners[i];
    return {
      x: a,
      y: c,
      z: l
    };
  }).reverse();
  return o.floors = t.floors.map((i) => ({
    id: i.id,
    points: s
  })), o.windows = t.walls.flatMap((i) => vt(de.WINDOW, i)).filter($e), o.doors = t.walls.flatMap(vt.bind(null, de.DOOR)).filter($e), o;
}
function vt(e, n) {
  var t;
  return ((t = n.features) == null ? void 0 : t.filter((o) => (o == null ? void 0 : o.type) === e).map((o) => {
    const r = ve(o.direction), s = { ...Gn(o.p1, o.p2) };
    s.y = +o.size.height / 2 + (he(o) ? o.groundClearance : 0);
    const i = { x: 0, y: r / Math.PI * 180, z: 0 };
    return {
      size: {
        x: o.size.width,
        y: o.size.height,
        z: o.size.depth
      },
      position: s,
      rotation: i
    };
  })) || [];
}
function mu(e) {
  return (n) => n.id === e;
}
function ct(e) {
  return e && ze(e);
}
function Ru(e) {
  return e && Ce(e);
}
function Mu(e) {
  return e && We(e);
}
function lt(e) {
  const n = e && J(e);
  return n ? ze(n.surface1) && ze(n.surface2) : !1;
}
function Ui(e) {
  const n = e && J(e);
  return n ? Ce(n.surface1) !== Ce(n.surface2) : !1;
}
function Fi(e) {
  const n = e && J(e);
  return n ? We(n.surface1) !== We(n.surface2) : !1;
}
function Gi(e) {
  e.addComponent(new ho()), e.addComponent(new Ko()), e.addComponent(new $o()), e.addComponent(new fn("Room")), e.addComponent(new qo()), e.addComponent(new uo()), e.addComponent(new pn()), e.addComponent(new et("Room"));
}
function Tu(e) {
  const n = we(e), t = n.filter(Ze), o = n.filter(ze), r = n.filter(Ce), s = n.filter(We), i = n.filter(Oo), a = t.filter(
    (l) => {
      var u;
      return (u = oe(l)) == null ? void 0 : u.surfaces.some(We);
    }
  ), c = t.filter(
    (l) => {
      var u;
      return (u = oe(l)) == null ? void 0 : u.surfaces.some(Ce);
    }
  );
  return {
    roomEntity: e,
    entities: n,
    cornerEntities: t,
    wallEntities: o,
    wallFeatureEntities: i,
    floorCornerEntities: c,
    ceilingCornerEntities: a,
    floorEntities: r,
    ceilingEntities: s
  };
}
function Au(e, n) {
  const t = rt(e), o = ce(e);
  if (!t || !o)
    return;
  const r = Ve(n), s = o.corners.filter((i) => !r.includes(fe(i)));
  e.addComponent(new ot(Ve(s)));
}
function Du(e, n, t, o) {
  const r = oe(e);
  if (!r)
    return;
  const s = Ve(n), i = r.surfaces.filter((c) => !s.includes(fe(c))).concat(o), a = r.edges.filter((c) => !s.includes(fe(c))).concat(t);
  e.addComponent(new In(Ve(i), Ve(a)));
}
function St(e = void 0, n, t, o, r, s) {
  const i = ft(e, n, s);
  return i.addComponent(new In(t, o)), w.setLocalPosition(i, r), Re(n, i), i;
}
function ut(e, n) {
  const t = n.createEntity();
  return t.addComponent(new Eo()), t.addComponent(new pn()), Re(e, t), e && t.addComponent(new fn(e)), t;
}
function To(e, n, t) {
  const o = t.createEntity(e);
  return o && (o.addComponent(new pn()), Re(n, o)), o ?? null;
}
function dt(e, n) {
  return n.entities.find((t) => {
    var r;
    const o = (r = Ne(t)) == null ? void 0 : r.id;
    return o && o === e;
  }) ?? null;
}
function ft(e = void 0, n = void 0, t) {
  return e && t.findEntity(e) || n && dt(n, t) || ut(n, t);
}
function Ot(e = void 0, n = void 0, t, o) {
  const r = ft(e, n, o);
  return r.addComponent(new ot(t)), r.addComponent(new Yo()), r.addComponent(new st(!1, !0)), r.addComponent(new Zo()), Re(n, r), r;
}
function Vi(e = void 0, n = void 0, t, o) {
  const r = Ot(e, n, t, o);
  return r.addComponent(new _o()), r;
}
function Bi(e = void 0, n = void 0, t, o) {
  const r = Ot(e, n, t, o);
  return r.addComponent(new co()), r;
}
function Hi(e = void 0, n = void 0, t, o) {
  const r = Ot(e, n, t, o);
  return r.addComponent(new oo()), r;
}
function ki(e, n, t) {
  return he(e) ? qi(e, n, t) : Ie(e) ? $i(e, n, t) : null;
}
function Ki(e, n, t) {
  const o = w.worldTransform(t), r = Xi(e, t), s = new rn(
    o.transformPosition(r.position),
    o.transformRotation(r.rotation)
  );
  return w.setWorldTransform(n, s), Bt.getClosestSnap(n, t) || void 0;
}
function $i(e, n, t) {
  const o = dt(e.id, t) ?? To(
    e.doorType === zn.OPENING ? "kvadrat-door-opening" : "kvadrat-door",
    e.id,
    n
  );
  if (!o)
    return null;
  if (o.addComponent(
    new st(
      o.hasComponent(U.DRAGGABLE_COMPONENT_ID),
      o.hasComponent(U.SELECTABLE_COMPONENT_ID)
    )
  ), o.addComponent(new ro(e.doorType, e.handleLocation)), o.addComponent(new nt(po(e.size))), Re(e.id, o), e.doorType !== zn.OPENING) {
    o.addComponent(new fo(e.openingDirection || jt.OUTWARDS));
    const r = A.findInHierarchy(o, oi) ?? ut(e.id + "_arc", o.entityManager);
    A.setParent(r, o), r.addComponent(new ti());
  }
  return o;
}
function qi(e, n, t) {
  const o = dt(e.id, t) ?? To("kvadrat-window", e.id, n);
  return o ? (o.addComponent(
    new st(
      o.hasComponent(U.DRAGGABLE_COMPONENT_ID),
      o.hasComponent(U.SELECTABLE_COMPONENT_ID)
    )
  ), o.addComponent(new Io(e.windowType, e.handleLocation)), o.addComponent(new nt(po(e.size))), Re(e.id, o), o) : null;
}
function Pn(e = void 0, n = void 0, t) {
  const o = ft(e, n, t);
  return o.addComponent(new io()), Re(n, o), o;
}
function Lu(e, n) {
  const t = e.getComponent(
    U.FUNCTIONAL_ZONES_LOCAL_COMPONENT_ID
  );
  if (t) {
    const o = rr(n, t.zones, "id");
    return new Et(o);
  } else
    return new Et(n);
}
function ji(e) {
  const { corner1: n, corner2: t } = J(e) || {};
  return !n || !t ? [] : w.localPosition(n).Y < w.localPosition(t).Y ? [n, t] : [t, n];
}
function Yi(e) {
  const n = tt(e);
  return (n == null ? void 0 : n.size) ?? new Bn(0, 0, 0);
}
function xu(e) {
  const n = oe(e), t = n == null ? void 0 : n.edges.find(lt);
  if (!t)
    return;
  const o = J(t);
  if (!o)
    return;
  const { corner1: r, corner2: s } = o;
  return r.id === e.id ? s : r;
}
function Ao(e) {
  const n = ce(e);
  if (n)
    return n.edges.filter(lt);
}
function Zi(e, n) {
  const t = w.localTransform(e), o = Lo(n);
  if (!o)
    return t;
  const r = Yi(e), s = new Z(
    t.position.X + o.X / 2 - r.width / 2,
    -t.position.Z + o.Z / 2 - r.height / 2,
    t.position.Y
  );
  return new rn(s, t.rotation);
}
function Xi(e, n) {
  const t = Lo(n);
  if (!t)
    return new rn(new Z(0, 0, 0));
  const o = new Z(
    -t.X / 2 + e.size.width / 2 + e.positionAlongWall,
    e.size.depth / 2,
    t.Z / 2 - e.size.height / 2 - (he(e) ? e.groundClearance : 0)
  ), r = sn.quaternionFromEulerRadians(-Math.PI / 2, 0, 0);
  return new rn(o, r);
}
function Ji(e) {
  var s;
  const n = tt(e);
  if (!n)
    return {
      id: "",
      positionAlongWall: 0,
      type: de.DOOR,
      // Need to default to something
      size: {
        width: 0,
        height: 0,
        depth: 0
      }
    };
  const t = {
    id: ((s = Ne(e)) == null ? void 0 : s.id) || "",
    positionAlongWall: 0,
    type: de.DOOR,
    size: {
      width: n.size.width,
      height: n.size.height,
      depth: n.size.depth
    }
  }, o = Vs(e);
  if (o)
    return {
      ...t,
      holeIndex: 0,
      type: de.DOOR,
      doorType: o.doorType,
      handleLocation: o.handleLocation
    };
  const r = Ei(e);
  return r ? {
    ...t,
    groundClearance: 0,
    holeIndex: 0,
    type: de.WINDOW,
    windowType: r.windowType,
    handleLocation: r.handleLocation
  } : t;
}
function vn(e) {
  var n;
  return (n = ei(e) || Qs(e)) == null ? void 0 : n.material;
}
function yu(e) {
  var d, h, I;
  const n = e.floorCornerEntities.reduce((g, M) => {
    var p;
    const x = (p = Ne(M)) == null ? void 0 : p.id;
    return x ? [
      ...g,
      {
        id: x,
        ..._e(w.localPosition(M))
      }
    ] : g;
  }, []), t = e.cornerEntities.reduce(
    (g, M) => Math.max(w.localPosition(M).Y, g),
    0
  ), o = e.wallEntities.reduce((g, M) => {
    var _, E;
    const x = (_ = Ne(M)) == null ? void 0 : _.id, p = rt(M);
    if (!x || !p)
      return g;
    const L = A.getDescendantsWithComponent(
      M,
      f.ROOM_PARAMETRIC_OBJECT_COMPONENT_ID
    ).reduce((R, D) => {
      var F, Q;
      const T = (F = Ne(D)) == null ? void 0 : F.id;
      if (!T || qs(D))
        return R;
      const y = Zi(D, M), S = gn(D) ? {
        groundClearance: y.position.Y
      } : {}, v = si(D) ? {
        openingDirection: (Q = ri(D)) == null ? void 0 : Q.openingDirection
      } : {}, P = {
        ...Ji(D),
        ...S,
        ...v,
        id: T,
        positionAlongWall: y.position.X
      };
      return [...R, P];
    }, []).sort(_n()), N = {
      materialId: (E = vn(M)) == null ? void 0 : E.id,
      height: t,
      id: x,
      leftIndex: n.findIndex(({ id: R }) => R === p.cornerPersistentIds[0]),
      rightIndex: n.findIndex(({ id: R }) => R === p.cornerPersistentIds[1]),
      features: L
    };
    return [...g, N];
  }, []), s = Nn(
    {
      corners: n,
      walls: o
    },
    {}
  ).map((g) => g.leftIndex).reverse(), [i] = e.floorEntities, [a] = e.ceilingEntities, c = [
    {
      id: "floor",
      materialId: i && ((d = vn(i)) == null ? void 0 : d.id),
      nodes: s
    }
  ], l = [
    {
      id: "ceiling",
      materialId: a && ((h = vn(a)) == null ? void 0 : h.id),
      nodes: s
    }
  ], u = ((I = ni(e.roomEntity)) == null ? void 0 : I.storage) ?? {};
  return {
    ...Ni(),
    materials: u,
    rooms: [
      {
        ceilings: l,
        floors: c,
        corners: n,
        walls: o
      }
    ]
  };
}
function Pu(e) {
  const n = oe(e);
  if (!n)
    return;
  const t = n.surfaces.filter(ct);
  if (!t || t.length !== 2)
    return;
  const [o, r] = t, s = qe(o), i = qe(r);
  if (!(!s || !i))
    return s[0].id === e.id ? [r, o] : [o, r];
}
function Do(e, n) {
  if (!e || !n)
    return;
  const t = qe(e), o = qe(n);
  if (!t || !o)
    return;
  const [r, s] = t, [i, a] = o, c = w.localPosition(r), l = w.localPosition(s), u = w.localPosition(i), d = w.localPosition(a);
  if (l.equals(u))
    return [c, l, d];
  if (c.equals(d))
    return [u, d, l];
}
function vu(e, n) {
  const t = Do(e, n);
  if (!t)
    return !1;
  const [o, r, s] = t, i = ln(_e(r), _e(o), _e(s)) - Math.PI / 2;
  return Vn(i);
}
function Qi(e) {
  var r;
  const n = ce(e);
  if (!n)
    return;
  const t = oe(n.corners[1]);
  if (!t)
    return;
  const o = t.surfaces.filter(ct);
  return e.id === ((r = o[0]) == null ? void 0 : r.id) ? o[1] : o[0];
}
function ea(e) {
  var r;
  const n = ce(e);
  if (!n)
    return;
  const t = oe(n.corners[0]);
  if (!t)
    return;
  const o = t.surfaces.filter(ct);
  return e.id === ((r = o[0]) == null ? void 0 : r.id) ? o[1] : o[0];
}
function Su(e) {
  const n = qe(e);
  if (!n)
    return 0;
  const [t, o] = n;
  return w.localPosition(t).distanceTo(w.localPosition(o));
}
function na(e) {
  const n = Ao(e);
  if (!n)
    return 0;
  const t = n[0], [o, r] = ji(t);
  return w.localPosition(o).distanceTo(w.localPosition(r));
}
function Lo(e) {
  var t;
  const n = (t = jo.colliderShapeComponent(e)) == null ? void 0 : t.polyhedron;
  if (n && Ii(n)) {
    const o = ta(n, je.UP);
    if (o)
      return o.axisAlignedBoundingBox.size;
  }
  return null;
}
function ta(e, n) {
  const t = e.faces.find((o, r) => oa(e.normals[r]).equals(n));
  if (t) {
    const o = t.indices.map((r) => e.vertices[r]);
    return Hn.singleSidedPolyhedronFromPolygon(o);
  }
  return null;
}
function oa(e) {
  return new Z(
    Math.trunc(Tn(e.X * 2, -1, 1)),
    Math.trunc(Tn(e.Y * 2, -1, 1)),
    Math.trunc(Tn(e.Z * 2, -1, 1))
  );
}
function ht(e) {
  (kt(e) ? e : [e]).forEach((t) => t.addComponent(new Eo()));
}
function xo(e) {
  (kt(e) ? e : [e]).forEach(di);
}
function Wu(e) {
  ht(we(e));
}
function ra(e) {
  xo(
    A.getDescendantsWithComponent(e, f.ROOM_UNDER_CONSTRUCTION_COMPONENT_ID)
  );
}
function wu(e, n, t) {
  const o = e.flatMap(Ao).filter((a) => {
    const c = a && J(a);
    return c ? sr(t, [c.corner1.id, c.corner2.id]).length === 0 : !1;
  });
  if (o.length !== 2)
    return;
  const { surface1: r, surface2: s } = J(o[0]), i = [r, s].find(
    (a) => a && (e[0].id === a.id || e[1].id === a.id)
  );
  if (i)
    return ce(i).corners[0].id === n ? [o[1], o[0]] : [o[0], o[1]];
}
function qe(e) {
  const n = ce(e);
  if (n)
    return n.corners.slice(0, 2);
}
function zu(e, n) {
  e.forEach((t, o) => {
    const r = Ge(t);
    r && (t.addComponent(
      new In(r.surfacePersistentIds, r.edgePersistentIds)
    ), w.setLocalPosition(t, n[o]));
  });
}
function bu(e, n) {
  let t = Number.MAX_SAFE_INTEGER, [o] = n;
  const r = n.length <= 2 ? 1 : n.length;
  for (let s = 0; s < r; s++) {
    const i = n[s], a = n[(s + 1) % n.length], [c, l] = sa(e, i, a);
    c < t && (t = c, o = l);
  }
  return o;
}
function sa(e, n, t) {
  const o = t.minus(n).normalize().dot(e.minus(n));
  if (o < 0)
    return [e.minus(n).size, n];
  if (o > t.minus(n).size)
    return [e.minus(t).size, t];
  const r = t.minus(n).normalize();
  return [r.cross(e.minus(n)).size, r.times(o).plus(n)];
}
function Uu(e) {
  const n = ce(e);
  if (!n)
    return;
  const [t, o] = n.edges.filter(lt).sort((i) => {
    const a = J(i);
    return a ? [a.corner1.id, a.corner2.id].includes(n.corners[0].id) ? -1 : 1 : 0;
  }), r = n.edges.find(Fi), s = n.edges.find(Ui);
  return { leftEdge: t, rightEdge: o, topEdge: r, bottomEdge: s };
}
function Fu(e, n) {
  const t = n.normalize(), o = e.dot(t);
  return t.times(o);
}
function Gu(e) {
  const n = A.parent(e);
  if (n)
    return A.getDescendantWithComponent(n, U.SELECTED_COMPONENT_ID);
}
function Wt(e) {
  const n = w.worldTransform(e);
  return We(e) || Ce(e) || ze(e) || ao(e) ? n.up : Ze(e) || so(e) || gn(e) ? n.forward.times(-1) : je.ZERO;
}
function Vu(e) {
  return ai(e.root) ?? null;
}
function Bu(e) {
  return we(e.root);
}
function ia(e) {
  return we(e.root).flatMap(
    (o) => A.children(o).filter((r) => !js(r))
  );
}
function aa(e) {
  return Array.from(
    /* @__PURE__ */ new Set([...Bs(e.root), ..._i(e.root)])
  );
}
function Hu(e) {
  return [...ia(e), ...aa(e)];
}
function ca(e) {
  return (A.findInUpwardsHierarchy(e, xt) || A.findInHierarchy(e, xt)) ?? null;
}
function ku(e) {
  var i;
  let n = [], t = [];
  const o = Ht.connectors(e), r = (i = e.getComponent(
    U.HOST_CONNECTIONS_COMPONENT_ID
  )) == null ? void 0 : i.connections;
  r && (t = r.filter((a) => !o.includes(a.hostConnector)));
  const s = Xo.getGuestConnections(e);
  return s && (n = s.filter((a) => !o.includes(a.guestConnector))), {
    guestConnections: n,
    hostConnections: t
  };
}
function Ku(e) {
  const n = A.parent(e);
  if (gn(e) && n) {
    const t = tt(e);
    return (
      // The ground clearance is basically the bottom point of the window. Calculate it by
      // first calculating the windows position on the wall's local space and finally subracting
      // the halfsize of the window
      // Note: This assumes that the wall is fixated at ground zero
      w.localPosition(n).Y - // The window's Z axis determines its "distance" from
      // the wall's center point since its transform is based on a wall
      // that's lying flat on the ground. Positive values = below center point, negative values = above
      w.localPosition(e).Z - ((t == null ? void 0 : t.size.height) ?? 0) / 2
    );
  }
  return 0;
}
function $u(e) {
  A.setParentMaintainTransform(e, null);
}
function qu(e, n) {
  const [t] = Jo.SORT_BY_DISTANCE.sortAndSelect(
    Bt.getMatchingSnapsInScene(e, n)
  );
  t && t.performMoveAndConnect();
}
function ju(e) {
  var n;
  return ((n = e.getComponent(U.FUNCTIONAL_ZONES_LOCAL_COMPONENT_ID)) == null ? void 0 : n.zones) ?? [];
}
function Yu(e) {
  return gn(e) || so(e);
}
function Zu(e) {
  const n = A.getDescendantWithComponent(e.root, U.CAMERA_COMPONENT_ID);
  return n ? w.worldPosition(n) : je.ZERO;
}
class la {
  // REWRITE TO FUNCTIONS AND PASS IN ENTITYMANAGER IN THIS FUNCTION ALONE????
  addRoomRelations(n) {
    const t = bs(n), o = ci(n), r = Hs(n), s = new ua(), i = [...t, ...o, ...r];
    ht(i), A.forEachInHierarchy(n, (a) => {
      Un(a) ? this.addSurfaceRelations(a, t, r, s) : ao(a) && this.addEdgeRelations(a, t, o, s);
    }), A.forEachInHierarchy(n, (a) => {
      const c = s.generateSurfaceComponent(a);
      c && a.addComponent(c);
    }), A.forEachInHierarchy(n, (a) => {
      const c = s.generateEdgeComponent(a);
      c && a.addComponent(c);
    }), A.forEachInHierarchy(n, (a) => {
      const c = s.generateCornerComponent(a);
      c && a.addComponent(c);
    }), xo(i);
  }
  addSurfaceRelations(n, t, o, r) {
    const s = rt(n), i = (s == null ? void 0 : s.cornerPersistentIds.map((c) => t.find((l) => fe(l) === c)).filter($e)) ?? [];
    if (i.length < 3)
      return console.warn(`Expected at least 3 corners for surface ${n.id}, but got ${i.length}`), null;
    const a = this.findSurfaceEdges(o, i);
    return i.forEach((c) => {
      r.addSurfaceToCorner(c, n);
    }), r.addCornerToSurface(n, i), a.forEach((c) => {
      r.addSurfaceToEdge(c, n), r.addEdgeToSurface(n, c);
    }), n;
  }
  addEdgeRelations(n, t, o, r) {
    const s = t.filter(
      (a) => {
        var c, l;
        return (l = (c = Ge(a)) == null ? void 0 : c.edgePersistentIds) == null ? void 0 : l.includes(fe(n));
      }
    );
    if (s.length !== 2)
      return console.warn(`Expected 2 corners for edge ${n.id}, but got ${s.length}`), null;
    const i = this.findEdgeSurfaces(o, s);
    return i.length ? (s.forEach((a) => {
      r.addEdgeToCorner(a, n), r.addCornerToEdge(n, a);
    }), i.forEach((a) => {
      r.addEdgeToSurface(a, n), r.addSurfaceToEdge(n, a);
    }), n) : (console.error(`Could not find any surface entities for edge ${n.id}. Edge will be ignored`), null);
  }
  findEdgeSurfaces(n, t) {
    const o = /* @__PURE__ */ new Map();
    t.forEach((a) => {
      var l;
      const c = Ge(a);
      (l = c == null ? void 0 : c.surfacePersistentIds) == null || l.forEach(
        (u) => o.set(u, (o.get(u) ?? 0) + 1)
      );
    });
    const r = Array.from(o.entries()).filter(([a, c]) => c === 2).map(([a]) => a);
    if (r.length < 1)
      return console.warn("No surface found connected to edge"), [];
    const [s, i] = r;
    return n.filter((a) => {
      const c = fe(a);
      return c === s || c === i;
    });
  }
  findSurfaceEdges(n, t) {
    const o = /* @__PURE__ */ new Map();
    t.forEach((s) => {
      var a;
      const i = Ge(s);
      (a = i == null ? void 0 : i.edgePersistentIds) == null || a.forEach((c) => o.set(c, (o.get(c) ?? 0) + 1));
    });
    const r = Array.from(o.entries()).filter(([s, i]) => i === 2).map(([s]) => s);
    return r.length < 3 ? (console.warn("Could not find 3 edges for surface"), []) : n.filter((s) => r.includes(fe(s)));
  }
}
class ua {
  constructor() {
    m(this, "cornerMap", /* @__PURE__ */ new Map());
    m(this, "surfaceMap", /* @__PURE__ */ new Map());
    m(this, "edgeMap", /* @__PURE__ */ new Map());
  }
  addSurfaceToCorner(n, t) {
    let o = this.cornerMap.get(n);
    o || (o = new wt(), this.cornerMap.set(n, o)), o.surfaces.add(t);
  }
  addSurfaceToEdge(n, t) {
    let o = this.edgeMap.get(n);
    o || (o = new zt(), this.edgeMap.set(n, o)), o.surfaces.add(t);
  }
  addEdgeToCorner(n, t) {
    let o = this.cornerMap.get(n);
    o || (o = new wt(), this.cornerMap.set(n, o)), o.edges.add(t);
  }
  addEdgeToSurface(n, t) {
    let o = this.surfaceMap.get(n);
    o || (o = new bt(), this.surfaceMap.set(n, o)), o.edges.add(t);
  }
  addCornerToEdge(n, t) {
    let o = this.edgeMap.get(n);
    o || (o = new zt(), this.edgeMap.set(n, o)), o.corners.add(t);
  }
  addCornerToSurface(n, t) {
    let o = this.surfaceMap.get(n);
    o || (o = new bt(), this.surfaceMap.set(n, o)), o.corners = t;
  }
  generateCornerComponent(n) {
    var t;
    return ((t = this.cornerMap.get(n)) == null ? void 0 : t.toComponent()) ?? null;
  }
  generateEdgeComponent(n) {
    var t;
    return ((t = this.edgeMap.get(n)) == null ? void 0 : t.toComponent()) ?? null;
  }
  generateSurfaceComponent(n) {
    var t;
    return ((t = this.surfaceMap.get(n)) == null ? void 0 : t.toComponent()) ?? null;
  }
}
class wt {
  constructor(n = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Set()) {
    this.surfaces = n, this.edges = t;
  }
  toComponent() {
    return new Us(Array.from(this.surfaces), Array.from(this.edges));
  }
}
class zt {
  constructor(n = /* @__PURE__ */ new Set(), t = /* @__PURE__ */ new Set()) {
    this.surfaces = n, this.corners = t;
  }
  toComponent() {
    const n = Array.from(this.corners), t = Array.from(this.surfaces);
    return n.length < 2 || t.length === 0 ? (console.warn("Not enough corners and surfaces to build a edge"), null) : new ks(n[0], n[1], t[0], t[1]);
  }
}
class bt {
  constructor(n = Array(), t = /* @__PURE__ */ new Set()) {
    this.corners = n, this.edges = t;
  }
  toComponent() {
    return new li(this.corners, Array.from(this.edges));
  }
}
class Xu extends ur {
}
class Ju extends lr {
}
class da extends ar {
}
class yo extends cr {
}
class Qu extends dr {
}
class ed extends yo {
  constructor() {
    super(
      f.ROOM_SURFACE_RELATIONS_COMPONENT_ID,
      f.ROOM_CORNER_COMPONENT_ID,
      f.ROOM_CORNER_RELATION_COMPONENT_ID,
      f.ROOM_UNDER_CONSTRUCTION_COMPONENT_ID
    );
    m(this, "id", "Kvadrat-CornerComponentSystem");
    m(this, "mandatoryComponents", [f.KVADRAT_COMPONENT_ID]);
    m(this, "doingChangesOnComponent", [
      U.CONNECTORS_COMPONENT_ID,
      U.LOCAL_TRANSFORM_COMPONENT_ID,
      U.WORLD_TRANSFORM_COMPONENT_ID,
      U.DISPLAY_NAME_COMPONENT_ID
    ]);
    m(this, "systemsBeforeMe", null);
    m(this, "systemsAfterMe", null);
  }
  onAddComponent(t, o) {
    Un(t) && this.tryAddCornerComponents(t);
  }
  onUpdateComponent(t, o, r) {
    Un(t) && this.tryAddCornerComponents(t);
  }
  onAddComponent2(t, o) {
    this.addCornerComponents(t);
  }
  onUpdateComponent2(t, o, r) {
    this.addCornerComponents(t);
  }
  onAddComponent3(t, o) {
    this.addCornerComponents(t);
  }
  onUpdateComponent3(t, o, r) {
    this.addCornerComponents(t);
  }
  onRemoveComponent4(t, o) {
    Ze(t) && this.addCornerComponents(t);
  }
  findCornerConnectedToSurface(t) {
    const o = ca(t);
    if (!o)
      return null;
    const r = fe(t);
    return A.children(o).find(
      (s) => {
        var i, a;
        return (a = (i = Ge(s)) == null ? void 0 : i.surfacePersistentIds) == null ? void 0 : a.includes(r);
      }
    ) ?? null;
  }
  tryAddCornerComponents(t) {
    const o = this.findCornerConnectedToSurface(t);
    o && this.addCornerComponents(o);
  }
  addCornerComponents(t) {
    if (pe(t))
      return;
    const o = dn(t), r = Fs(t).map(
      (a) => Fn(a).cornerPoints
      // risky or must always work?
    ), s = kn.cornerDefinitions(o, r);
    s.asComponents().forEach((a) => {
      t.addComponent(a);
    });
    const i = this.getCornerType(s.adjacentSurfaceTypes);
    t.addComponent(new fn(`${i} - ${t.id}`));
  }
  getCornerType(t) {
    return t.some((o) => o === Ee.FLOOR) ? "FloorCorner" : t.some((o) => o === Ee.CEILING) ? "CeilingCorner" : "Corner";
  }
}
class nd extends yo {
  constructor() {
    super(
      f.ROOM_SURFACE_RELATIONS_COMPONENT_ID,
      f.ROOM_EDGE_RELATION_COMPONENT_ID,
      f.ROOM_CORNER_COMPONENT_ID,
      f.ROOM_UNDER_CONSTRUCTION_COMPONENT_ID
    );
    m(this, "id", "Kvadrat-EdgeComponentSystem");
    m(this, "mandatoryComponents", [f.KVADRAT_COMPONENT_ID]);
    m(this, "doingChangesOnComponent", [
      U.CONNECTORS_COMPONENT_ID,
      U.LOCAL_TRANSFORM_COMPONENT_ID,
      U.WORLD_TRANSFORM_COMPONENT_ID,
      U.DISPLAY_NAME_COMPONENT_ID
    ]);
    m(this, "systemsBeforeMe", null);
    m(this, "systemsAfterMe", null);
  }
  tryToAddEdgeComponentsFromEdgeRelation(t, o) {
    const { surface1: r, surface2: s } = o;
    r.isDisposed || s.isDisposed || this.addEdgeComponents(t, r, s);
  }
  tryToAddEdgeComponentsFromSurface(t) {
    var r;
    (((r = ce(t)) == null ? void 0 : r.edges) ?? []).forEach((s) => {
      const i = J(s);
      if (!i)
        return;
      const a = i.surface1.id === t.id ? i.surface2 : i.surface1;
      this.addEdgeComponents(s, t, a);
    });
  }
  addEdgeComponents(t, o, r) {
    const s = Fn(o), i = Fn(r), a = Ks(t), c = kn.edgeDefinitions(
      a.cornerPoint1,
      a.cornerPoint2,
      s.cornerPoints,
      i.cornerPoints
    );
    c.asComponents().forEach((u) => {
      t.addComponent(u);
    });
    const l = this.getEdgeType(c.adjacentSurfaceTypes);
    t.addComponent(new fn(`${l} - ${t.id}`));
  }
  getEdgeType(t) {
    const [o, r] = t;
    return o === Ee.WALL && r === Ee.WALL ? "FloorCeilingEdge" : o === Ee.FLOOR || r === Ee.FLOOR ? "FloorEdge" : o === Ee.CEILING || r === Ee.CEILING ? "CeilingEdge" : "Edge";
  }
  onAddComponent(t, o) {
    pe(t) || this.tryToAddEdgeComponentsFromSurface(t);
  }
  onUpdateComponent(t, o, r) {
    pe(t) || this.tryToAddEdgeComponentsFromSurface(t);
  }
  onAddComponent2(t, o) {
    pe(t) || this.tryToAddEdgeComponentsFromEdgeRelation(t, o);
  }
  onUpdateComponent2(t, o, r) {
    pe(t) || this.tryToAddEdgeComponentsFromEdgeRelation(t, r);
  }
  onUpdateComponent3(t, o, r) {
    if (pe(t))
      return;
    const s = oe(t);
    s == null || s.edges.forEach((i) => {
      const a = J(i);
      a && this.addEdgeComponents(i, a.surface1, a.surface2);
    });
  }
  onRemoveComponent4(t, o) {
    const r = J(t);
    r && this.tryToAddEdgeComponentsFromEdgeRelation(t, r);
  }
}
const Ut = 3, He = 0, ke = 1;
function fa(e, n) {
  const t = Hn.surfaceNormal(n), o = n[0];
  return e.projectOnPlane(t, o).minus(e).equals(je.ZERO);
}
function Oa(e) {
  return e.length < 4 ? !0 : e.every((n) => fa(n, e));
}
function ha(e, n) {
  const o = n.map((c, l) => c.minus(e[l])), r = o.map(Ea);
  let s, i;
  r[ke].X - r[He].X > 1e-6 || r[ke].Y > 1e-6 ? s = 1 : r[He].X - r[ke].X > 1e-6 || r[He].Y > 1e-6 ? s = -1 : s = 0;
  const a = Ft(n) - Ft(e);
  return s *= Math.abs(a) > 1e-6 ? Math.sign(a) : 0, o[Ut].Z > 1e-6 ? i = 1 : o[Ut].Z < -1e-6 ? i = -1 : i = 0, new Z(s, 0, i);
}
function Ea(e) {
  return new Z(Math.abs(e.X), Math.abs(e.Y), Math.abs(e.Z));
}
function Ft(e) {
  return Math.sqrt(Math.pow(e[ke].X - e[He].X, 2) + Math.pow(e[ke].Y - e[He].Y, 2));
}
function Po(e, n) {
  try {
    return Hn.polyhedronFromPolygon(e, n);
  } catch {
    return [];
  }
}
function _a(e, n) {
  const t = [], o = ea(e), r = Qi(e);
  if (o && r) {
    const l = Gt(e, o, n), u = Gt(e, r, n);
    l && u && t.push(l[0], u[0], u[1], l[1]);
  }
  const s = w.worldTransform(e), i = t.map((l) => s.inverseTransformPosition(l).xzy());
  return Po(i, na(e)).map(
    (l) => l.rotate(sn.quaternionFromEulerRadians(-Math.PI / 2, 0, 0))
  );
}
function Gt(e, n, t) {
  const o = Do(e, n);
  if (o) {
    const r = o[1], s = Ia(
      r,
      Wt(e),
      Wt(n),
      t
    );
    return [r, s];
  }
  return null;
}
function Ia(e, n, t, o) {
  const r = n.plus(t).times(-1).normalize(), s = o / Math.cos(n.angle(t) / 2);
  return e.plus(r.times(s));
}
const Vt = 1e-3;
class td extends da {
  constructor() {
    super(
      U.LOCAL_TRANSFORM_COMPONENT_ID,
      f.ROOM_SURFACE_RELATIONS_COMPONENT_ID,
      f.ROOM_UNDER_CONSTRUCTION_COMPONENT_ID
    );
    m(this, "id", "Kvadrat-RoomSurfaceComponentSystem");
    m(this, "mandatoryComponents", [f.KVADRAT_COMPONENT_ID]);
    m(this, "doingChangesOnComponent", [
      U.CONNECTORS_COMPONENT_ID,
      U.LOCAL_TRANSFORM_COMPONENT_ID,
      U.WORLD_TRANSFORM_COMPONENT_ID,
      U.DISPLAY_NAME_COMPONENT_ID,
      U.COLLIDER_SHAPE_COMPONENT_ID
    ]);
    m(this, "systemsBeforeMe", null);
    m(this, "systemsAfterMe", null);
  }
  onUpdateComponent(t, o, r) {
    if (!Ze(t))
      return;
    const s = oe(t);
    s && s.surfaces.forEach((i) => this.surfaceComponentUpdated(i));
  }
  onAddComponent2(t, o) {
    this.surfaceComponentUpdated(t, o);
  }
  onUpdateComponent2(t, o, r) {
    this.surfaceComponentUpdated(t, r);
  }
  onRemoveComponent3(t, o) {
    this.surfaceComponentUpdated(t);
  }
  getSanitizedPoints(t, o) {
    const r = w.worldTransform(o);
    if (t[0].equals(t[1])) {
      const s = r.right.times(Vt);
      t[1] = t[1].plus(s), t[2] = t[2].plus(s);
    }
    if (t[1].equals(t[2])) {
      const s = r.forward.times(-Vt);
      t[2] = t[2].plus(s), t[3] = t[3].plus(s);
    }
    return t;
  }
  addRoomSurfaceComponents(t, o) {
    const r = this.getSanitizedPoints(o, t), s = kn.surfaceDefinitions(r), i = s.entityTransform, a = r.map((h) => i.inverseTransformPosition(h));
    if (!Oa(a))
      return;
    const c = 30, l = ze(t) ? _a(t, c) : Po(a, c);
    l.length && t.addComponent(
      // Include ids so the visualization debugger systems can render a shape for this collider. The actual ID value kind of matters
      new Qo(
        l.length === 1 ? l[0] : new er(l),
        l.map((h, I) => `whatever_${t.id}_${I}`)
      )
    );
    const d = Ht.connectors(t).find(
      (h) => nr.isSurfaceConnector(h)
    );
    if (d && ii(t).length) {
      const h = sn.axisAlignedBoxFromVertices(d.vertices), g = sn.axisAlignedBoxFromVertices(s.connector.vertices).size.minus(h.size);
      if (!g.equals(je.ZERO)) {
        const M = w.worldTransform(t), p = d.vertices.map((_) => M.transformPosition(_)).map((_) => i.inverseTransformPosition(_)), L = ha(p, a), N = new Oi(g, L);
        t.addComponent(N), hi(t);
      }
    }
    s.asComponents().forEach((h) => {
      t.addComponent(h);
    });
  }
  surfaceComponentUpdated(t, o = ce(t)) {
    if (pe(t) || !o)
      return;
    const r = /* @__PURE__ */ new Set([t]);
    for (const s of o.edges) {
      const i = J(s);
      i && (r.add(i.surface1), r.add(i.surface2));
    }
    for (const s of r) {
      const i = ce(s);
      i && this.addRoomSurfaceComponents(s, i.cornerPoints);
    }
  }
}
const nn = "ceiling-corner", Sn = "ceiling-edge", Wn = "floor-ceiling-edge", wn = "floor-edge";
class od {
  constructor(n) {
    m(this, "entityManager");
    m(this, "kvadratToEntityId", /* @__PURE__ */ new Map());
    this.coreServices = n, this.entityManager = this.coreServices.entityManager;
  }
  // Revise this whether its needed or the updating is to happen elsewhere.
  cleanupRoomEntityRelations(n) {
    n.forEach((t) => {
      A.setParent(t, null), $s(t), ui(t), Gs(t);
    });
  }
  disposeOldRoomEntitiesWithoutKvadratComponents(n) {
    n.forEach((t) => {
      A.parent(t) || this.entityManager.disposeEntity(t);
    });
  }
  generateRoomFromBlueprint(n, t) {
    n.removeComponent(f.BLUEPRINT_COMPONENT_ID), this.kvadratToEntityId = new Map(
      we(n).map((l) => [Ne(l).id, l.id])
    );
    const o = mo(t.rooms[0], t.materials), r = we(n);
    ht(r), this.cleanupRoomEntityRelations(r), Gi(n), n.addComponent(new uo(t.materials));
    const s = o.floors.map((l) => {
      const u = l.nodes.map((d) => o.corners[d].id);
      return this.generateFloorEntity(l, u, t.materials);
    }), i = o.ceilings.map((l) => {
      const u = [...l.nodes].reverse().map((d) => `${nn}-${o.corners[d].id}`);
      return this.generateCeilingEntity(l, u, t.materials);
    });
    [...o.walls.flatMap((l) => {
      const u = `${Wn}-${l.id}`, d = `${Sn}-${l.id}`, h = `${wn}-${l.id}`;
      return [
        // Wall
        this.generateWallEntity(l, o.corners, t.materials),
        // Floor Corner
        this.generateFloorCornerEntity(o.floors[0].id, l, o.corners),
        // Ceiling Corner
        this.generateCeilingCornerEntity(o.ceilings[0].id, l, o.corners),
        // Edge between floor and ceiling
        Pn(this.useId(u), u, this.entityManager),
        // Ceiling Edge
        Pn(this.useId(d), d, this.entityManager),
        // Floor edge
        Pn(this.useId(h), h, this.entityManager)
      ];
    }), ...s, ...i].forEach((l) => {
      A.setParentMaintainTransform(l, n);
    }), new la().addRoomRelations(n), ra(n);
    for (const l of o.walls)
      this.generateWallFeatureEntities(l);
    this.disposeOldRoomEntitiesWithoutKvadratComponents(r);
  }
  generateFloorEntity(n, t, o) {
    const r = Bi(this.useId(n.id), n.id, t, this.entityManager), s = n.materialId && o[n.materialId];
    return s && r.addComponent(new on(s)), r;
  }
  generateCeilingEntity(n, t, o) {
    const r = Hi(
      this.useId(n.id),
      n.id,
      t,
      this.entityManager
    ), s = n.materialId && o[n.materialId];
    return s && r.addComponent(new on(s)), r;
  }
  generateWallFeatureEntities(n) {
    var o;
    const t = this.entityManager.findEntity(this.useId(n.id));
    t && ((o = n.features) == null || o.forEach((r) => {
      const s = ki(
        r,
        this.coreServices.productManager,
        this.entityManager
      );
      if (s) {
        const i = Ki(r, s, t);
        i == null || i.performMoveAndConnect(), A.setParentMaintainTransform(s, t);
      }
    }));
  }
  generateWallEntity(n, t, o) {
    const r = [
      t[n.leftIndex].id,
      t[n.rightIndex].id,
      `${nn}-${t[n.rightIndex].id}`,
      `${nn}-${t[n.leftIndex].id}`
    ], s = Vi(this.useId(n.id), n.id, r, this.entityManager), i = n.materialId && o[n.materialId];
    return i && s.addComponent(new on(i)), s;
  }
  // TODO is this method still necessary now that we use Kvadrat IDs to track relations?
  useId(n) {
    const t = this.kvadratToEntityId.get(n);
    if (t)
      return t;
    {
      const r = ut(n, this.entityManager).id;
      return this.kvadratToEntityId.set(n, r), r;
    }
  }
  generateFloorCornerEntity(n, t, o) {
    const r = o[t.leftIndex].id, s = St(
      this.useId(r),
      r,
      [t.previousWall.id, t.id, n],
      [
        `${wn}-${t.previousWall.id}`,
        `${wn}-${t.id}`,
        `${Wn}-${t.id}`
      ],
      yt(t.p1),
      this.entityManager
    );
    return this.kvadratToEntityId.set(r, s.id), s;
  }
  generateCeilingCornerEntity(n, t, o) {
    const r = `${nn}-${o[t.leftIndex].id}`;
    return St(
      this.useId(r),
      r,
      [t.previousWall.id, t.id, n],
      [
        `${Sn}-${t.previousWall.id}`,
        `${Sn}-${t.id}`,
        `${Wn}-${t.id}`
      ],
      yt(t.p1).plus(new Z(0, t.height, 0)),
      this.entityManager
    );
  }
}
const vo = 0, So = 6, pa = parseFloat(`${vo}.${So}`), ga = {
  belowVersion: pa,
  migrate(e) {
    const n = {
      versionMajor: vo,
      versionMinor: So
    };
    return Na(e) ? {
      ...e,
      ...n
    } : {
      ...Ra(e, 1e-3),
      ...n
    };
  }
};
function Na(e) {
  return e.rooms.some(
    (n) => n.walls.some((t) => {
      const o = n.vertices[t.leftIndex], r = n.vertices[t.rightIndex];
      return B(K(o, r)) >= 1e3;
    })
  );
}
function Ca(e) {
  return (e == null ? void 0 : e.type) === "WINDOW";
}
function ma(e) {
  return typeof e != "number";
}
function Ra(e, n) {
  const t = e.rooms.map((o) => {
    const r = o.vertices.map((i) => O(i.x / n, i.y / n, i.z / n)), s = o.walls.map((i) => {
      var d, h;
      const a = i.thickness ? i.thickness / n : null;
      let c;
      ma(i.height) ? c = {
        vertices: i.height.vertices.map((I) => C(I.x / n, I.y / n))
      } : c = i.height / n;
      const l = (d = i.features) == null ? void 0 : d.map((I) => {
        const g = {
          ...I,
          positionAlongWall: I.positionAlongWall / n,
          size: {
            width: I.size.width / n,
            height: I.size.height / n,
            depth: I.size.depth / n
          }
        };
        return Ca(I) ? {
          ...g,
          groundClearance: I.groundClearance / n
        } : g;
      }), u = (h = i.holes) == null ? void 0 : h.map((I) => ({
        vertices: I.vertices.map((g) => C(g.x / n, g.y / n))
      }));
      return a ? {
        ...i,
        height: c,
        thickness: a,
        features: l,
        holes: u
      } : {
        ...i,
        height: c,
        features: l,
        holes: u
      };
    });
    return {
      ...o,
      vertices: r,
      walls: s
    };
  });
  return {
    ...e,
    rooms: t
  };
}
const Wo = 0, wo = 7, Ma = parseFloat(`${Wo}.${wo}`);
var zo = /* @__PURE__ */ ((e) => (e.DOOR = "DOOR", e.WINDOW = "WINDOW", e))(zo || {});
const Ta = {
  belowVersion: Ma,
  migrate(e) {
    return {
      ...Aa(e),
      versionMajor: Wo,
      versionMinor: wo
    };
  }
};
function Aa(e) {
  const { rooms: n } = e, t = n.flatMap((r) => r.walls).flatMap((r) => r.features).map((r) => r == null ? void 0 : r.id).filter($e), o = n.map((r) => ({
    ...r,
    walls: r.walls.map((s) => {
      var i;
      return {
        ...s,
        features: (i = s.features) == null ? void 0 : i.map((a) => {
          const c = a.id ?? go(t, "wall-feature-");
          return t.push(c), {
            ...a,
            type: zo[a.type],
            id: c
          };
        })
      };
    })
  }));
  return {
    ...e,
    rooms: o,
    materials: {}
  };
}
const bo = 0, Uo = 8, Da = parseFloat(`${bo}.${Uo}`);
var Fo = /* @__PURE__ */ ((e) => (e.DOOR = "DOOR", e.WINDOW = "WINDOW", e))(Fo || {});
const La = {
  belowVersion: Da,
  migrate(e) {
    return xa(e);
  }
};
function xa(e) {
  return {
    ...e,
    rooms: e.rooms.map(({ vertices: n, walls: t, ...o }) => ({
      ...o,
      walls: t.map(({ features: r, ...s }) => ({
        ...s,
        features: r == null ? void 0 : r.map(({ type: i, ...a }) => ({
          ...a,
          type: Fo[i]
        }))
      })),
      corners: n.map((r) => ({
        ...r,
        id: go([], "corner-")
      }))
    })),
    versionMajor: bo,
    versionMinor: Uo
  };
}
const Go = 0, Vo = 8, ya = parseFloat(`${Go}.${Vo}`), Pa = {
  belowVersion: ya,
  alwaysRun: !0,
  migrate(e) {
    const n = e.rooms.map((t) => {
      var a, c;
      const r = Nn(t, e.materials).map((l) => l.leftIndex).reverse(), s = [
        {
          id: "floor",
          materialId: (a = t.floors[0]) == null ? void 0 : a.materialId,
          nodes: r
        }
      ], i = [
        {
          id: "ceiling",
          materialId: (c = t.ceilings[0]) == null ? void 0 : c.materialId,
          nodes: r
        }
      ];
      return {
        ...t,
        ceilings: i,
        floors: s
      };
    });
    return {
      ...e,
      rooms: n,
      versionMajor: Go,
      versionMinor: Vo
    };
  }
}, va = [
  // prettier-ignore
  ga,
  Ta,
  La,
  Pa
];
function Sa(e, n) {
  const [t, o] = e.toString().split("."), r = parseInt(t, 10), s = parseInt(o, 10), i = parseInt(n.versionMajor, 10), a = parseInt(n.versionMinor, 10);
  return i < r || i === r && a < s;
}
function rd(e) {
  const n = ir(e), t = [...va].sort((o, r) => o.belowVersion - r.belowVersion).filter((o) => Sa(o.belowVersion, n) || o.alwaysRun).reduce((o, r) => r.migrate(o), n);
  return t.versionMajor = Yn, t.versionMinor = Zn, t;
}
export {
  K as $,
  zs as A,
  Vc as B,
  ne as C,
  ws as D,
  X as E,
  Se as F,
  mo as G,
  go as H,
  iu as I,
  _n as J,
  Pc as K,
  de as L,
  As as M,
  Wi as N,
  Hr as O,
  jt as P,
  su as Q,
  $r as R,
  Ci as S,
  uu as T,
  lu as U,
  au as V,
  zn as W,
  hu as X,
  he as Y,
  V as Z,
  B as _,
  Ws as a,
  Lo as a$,
  Ou as a0,
  Pi as a1,
  vi as a2,
  at as a3,
  gu as a4,
  Pt as a5,
  yi as a6,
  no as a7,
  b as a8,
  te as a9,
  Ve as aA,
  Vi as aB,
  fe as aC,
  J as aD,
  dn as aE,
  $e as aF,
  In as aG,
  Ge as aH,
  ze as aI,
  _o as aJ,
  We as aK,
  oo as aL,
  Ce as aM,
  co as aN,
  ot as aO,
  io as aP,
  Ks as aQ,
  dt as aR,
  et as aS,
  pn as aT,
  ai as aU,
  we as aV,
  Xu as aW,
  Yu as aX,
  tl as aY,
  ol as aZ,
  Un as a_,
  Ua as aa,
  _u as ab,
  pu as ac,
  Fa as ad,
  it as ae,
  du as af,
  mu as ag,
  pc as ah,
  Nc as ai,
  gc as aj,
  cn as ak,
  Ue as al,
  _c as am,
  me as an,
  Ja as ao,
  C as ap,
  Uc as aq,
  bc as ar,
  Ic as as,
  Le as at,
  la as au,
  ce as av,
  el as aw,
  bu as ax,
  xt as ay,
  ut as az,
  fc as b,
  xu as b$,
  tt as b0,
  oi as b1,
  Lu as b2,
  ju as b3,
  Ju as b4,
  ci as b5,
  Oo as b6,
  zl as b7,
  Wl as b8,
  ca as b9,
  js as bA,
  Bu as bB,
  Gi as bC,
  od as bD,
  Qi as bE,
  ea as bF,
  vu as bG,
  Vu as bH,
  Tu as bI,
  yu as bJ,
  Zu as bK,
  ki as bL,
  Ki as bM,
  ql as bN,
  kl as bO,
  ro as bP,
  fo as bQ,
  Ui as bR,
  Fi as bS,
  qe as bT,
  Wu as bU,
  yt as bV,
  $u as bW,
  on as bX,
  qu as bY,
  zu as bZ,
  Vn as b_,
  Ol as ba,
  Qs as bb,
  Il as bc,
  ei as bd,
  uo as be,
  Qu as bf,
  td as bg,
  nd as bh,
  ed as bi,
  Tl as bj,
  Al as bk,
  ml as bl,
  Rl as bm,
  ku as bn,
  Ne as bo,
  ao as bp,
  Gu as bq,
  Fu as br,
  ji as bs,
  cc as bt,
  Ea as bu,
  Fs as bv,
  Wt as bw,
  Uu as bx,
  ra as by,
  da as bz,
  vc as c,
  Ni as c$,
  oe as c0,
  ct as c1,
  Mu as c2,
  Ru as c3,
  Pu as c4,
  wu as c5,
  Pn as c6,
  ht as c7,
  Du as c8,
  Au as c9,
  se as cA,
  ru as cB,
  Tc as cC,
  Xl as cD,
  De as cE,
  Zl as cF,
  Jl as cG,
  Ms as cH,
  Wc as cI,
  Nu as cJ,
  wc as cK,
  Iu as cL,
  eo as cM,
  Gn as cN,
  Yl as cO,
  fu as cP,
  xc as cQ,
  cu as cR,
  Qa as cS,
  dc as cT,
  ft as cU,
  Eu as cV,
  nu as cW,
  ou as cX,
  rd as cY,
  Cu as cZ,
  jr as c_,
  pl as ca,
  _e as cb,
  jl as cc,
  _i as cd,
  Bs as ce,
  El as cf,
  Oc as cg,
  yc as ch,
  hc as ci,
  Ec as cj,
  tu as ck,
  gi as cl,
  Ku as cm,
  Sc as cn,
  Rs as co,
  zr as cp,
  Je as cq,
  eu as cr,
  Qn as cs,
  Ac as ct,
  Dc as cu,
  Yr as cv,
  Rc as cw,
  Mc as cx,
  ie as cy,
  Lc as cz,
  re as d,
  ue as d$,
  aa as d0,
  ia as d1,
  Hu as d2,
  Yn as d3,
  Zn as d4,
  pt as d5,
  ge as d6,
  ye as d7,
  Kr as d8,
  ka as d9,
  Wr as dA,
  jn as dB,
  vr as dC,
  Va as dD,
  Ha as dE,
  Ba as dF,
  Qe as dG,
  W as dH,
  Ga as dI,
  ja as dJ,
  Fr as dK,
  Ka as dL,
  kr as dM,
  ve as dN,
  oc as dO,
  lc as dP,
  wr as dQ,
  br as dR,
  ee as dS,
  tc as dT,
  ec as dU,
  yr as dV,
  ns as dW,
  Xt as dX,
  qa as dY,
  Sr as dZ,
  G as d_,
  Pr as da,
  Gr as db,
  uc as dc,
  $a as dd,
  nc as de,
  Ur as df,
  sc as dg,
  rc as dh,
  ac as di,
  ic as dj,
  Oe as dk,
  Br as dl,
  _s as dm,
  Zr as dn,
  tn as dp,
  ln as dq,
  Qr as dr,
  qr as ds,
  Za as dt,
  Vr as du,
  Xa as dv,
  gt as dw,
  qt as dx,
  An as dy,
  Ya as dz,
  f as e,
  Gl as e$,
  Bc as e0,
  Hc as e1,
  kc as e2,
  Ze as e3,
  Kc as e4,
  bs as e5,
  $c as e6,
  Us as e7,
  qc as e8,
  jc as e9,
  Cl as eA,
  ti as eB,
  si as eC,
  Ml as eD,
  nt as eE,
  ii as eF,
  ho as eG,
  Dl as eH,
  Ll as eI,
  rt as eJ,
  xl as eK,
  li as eL,
  Fn as eM,
  yl as eN,
  Pl as eO,
  ui as eP,
  Eo as eQ,
  vl as eR,
  pe as eS,
  Sl as eT,
  di as eU,
  st as eV,
  wl as eW,
  bl as eX,
  fi as eY,
  Ul as eZ,
  Fl as e_,
  Yc as ea,
  Gs as eb,
  Zc as ec,
  Xc as ed,
  Hs as ee,
  Jc as ef,
  ks as eg,
  Qc as eh,
  nl as ei,
  $s as ej,
  qs as ek,
  rl as el,
  sl as em,
  il as en,
  al as eo,
  cl as ep,
  ll as eq,
  Re as er,
  ul as es,
  dl as et,
  fl as eu,
  hl as ev,
  _l as ew,
  ni as ex,
  gl as ey,
  Nl as ez,
  to as f,
  Oi as f0,
  Vl as f1,
  Bl as f2,
  hi as f3,
  Hl as f4,
  Kl as f5,
  Io as f6,
  Ei as f7,
  $l as f8,
  Fc as f9,
  Gc as fa,
  Ls as fb,
  mc as g,
  Cc as h,
  zc as i,
  Vs as j,
  be as k,
  lo as l,
  ri as m,
  Su as n,
  vs as o,
  Ss as p,
  ys as q,
  Ql as r,
  Ps as s,
  gn as t,
  so as u,
  O as v,
  Ds as w,
  Ie as x,
  Ji as y,
  Ts as z
};
//# sourceMappingURL=blueprintMigration-DWnU48_4.js.map
